var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _g, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFuelLogo = function SvgFuelLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 506,
    viewBox: "0 0 780 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.801 307.192H734.086L737.072 305.699L736.474 305.4L735.877 304.803L735.28 304.504L734.683 304.206L734.086 303.907L733.488 303.609L733.19 303.31L732.592 303.011H732.294H731.995H731.697H731.398H731.099H730.801V302.713V302.414H730.502V302.116V301.817H730.204V301.518H729.905V301.22H729.606L729.308 300.921H729.009L728.711 300.622L728.412 300.324L727.815 300.025L727.217 299.727L726.62 299.428L725.724 299.129L724.829 298.831L724.231 298.532L723.336 298.234H722.44L721.544 297.935H720.648L719.454 297.636H718.558L717.662 297.338H716.766H715.87H714.676L717.065 295.845L717.363 295.546H717.662V295.247L717.363 294.65V294.352L717.065 294.053L716.467 293.456L715.87 293.157L714.974 292.56L714.377 292.261L713.481 291.664L712.586 291.366L711.69 290.768L710.794 290.47L709.898 290.171L709.002 289.872L708.106 289.574L707.211 289.275L706.315 288.977L705.419 288.678H704.523L704.822 288.379H706.315L709.301 286.886L708.704 286.289L708.106 285.991L707.509 285.692L706.912 285.393L706.315 285.095L706.016 284.796L705.419 284.498L704.822 284.199H704.224H703.627H703.03H702.433H701.836H701.238H700.641H700.044L699.447 283.9L698.849 283.602L698.252 283.303L697.954 283.004L697.356 282.706L696.759 282.407L696.162 281.81L695.565 281.511H695.266H694.669H694.37H693.773H693.474H692.877H692.579H692.28L693.773 280.616L693.176 280.317L692.877 280.018L692.28 279.72L691.683 279.421L691.086 278.824L690.488 278.525L689.891 278.227L689.294 277.928H688.995H688.697H688.398H688.099H687.801H687.502H687.204H686.905V277.629V277.331V277.032L686.606 276.734V276.435H686.308V276.136H686.009V275.838H685.711H685.412V275.539H685.113L684.815 275.241H684.516L684.218 274.942H683.62H683.023H682.426H681.829H681.231H680.634H680.037H679.141L677.051 276.136L676.155 275.838L679.44 274.046V273.747L679.738 273.449V273.15V272.852L679.44 272.553L679.141 271.956L678.544 271.657L678.245 271.359L677.349 270.761L676.454 270.164L675.558 269.866L674.662 269.268L673.766 268.97L672.87 268.372L671.974 268.074L670.78 267.775L669.884 267.477L668.69 267.178L667.794 266.879L666.599 266.581L665.405 266.282H669.586L672.572 264.491L671.974 264.192L671.377 263.893L671.079 263.595L670.481 263.296L669.884 262.997L669.287 262.699L668.69 262.4L668.093 262.102H667.495H666.599H666.002H665.405H664.509H663.912H663.016H662.419H661.822H660.926H660.329H659.433H658.836H658.238H657.343H656.745H655.85H655.252H654.655H653.759H653.162H652.266L487.732 166.845H481.461H474.294L465.634 162.067H459.364L335.141 233.734L350.571 242.688L289.148 278.227L311.843 291.366V291.664H316.621L334.121 281.511H417.558L473.229 313.677L412.184 348.997L434.878 362.136V362.435H439.656L456.641 352.581H540.586L606.28 390.504H612.551L621.211 385.428H628.079H634.349L750.211 318.539L730.801 307.192ZM349.562 272.553H402.03L391.249 266.296C389.689 267.187 388.129 268.078 386.496 268.97H375.447H364.697H355.739L349.562 272.553ZM690.638 282.407L691.981 281.511H692.28L690.787 282.407H690.638ZM690.638 282.407L689.294 283.303L687.502 282.407H690.638ZM509.531 339.74C511.064 338.904 512.532 338.068 513.996 337.231L525.058 343.622H472.082L478.774 339.74H487.732H498.482H509.531Z",
    fill: "#39444F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.583 271.955L668.688 271.358C668.986 271.657 669.285 271.657 669.583 271.955Z",
    fill: "#413F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.847 285.094L289.152 271.955L420.243 196.108L443.236 209.247L311.847 285.094Z",
    fill: "#F4EEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.293 239.706L420.244 196.108L443.237 209.247L367.987 252.844L345.293 239.706Z",
    fill: "#B9B2B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.402 266.282L328.874 275.24H311.853L306.18 271.955L315.735 266.282H344.402Z",
    fill: "#B9B2B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.898 228.956L350.968 262.4C347.982 262.4 344.996 262.4 342.01 262.4L328.273 254.337L329.468 253.74L330.662 253.143L331.857 252.546L333.051 251.949L334.246 251.351L335.44 250.754L336.635 250.157L337.829 249.56L339.023 248.962L340.218 248.365L341.412 247.768L342.607 247.171L343.801 246.574L344.996 245.976L346.19 245.379L347.385 244.782L348.579 244.185L349.773 243.587L350.968 242.99L352.162 242.393L353.357 241.796L354.551 241.199L355.746 240.601L356.94 240.004L358.135 239.407L359.329 238.81L360.523 238.212L361.718 237.615L362.912 237.018L364.107 236.421L365.301 235.824L366.496 235.226L367.093 234.928L367.69 234.629L368.287 234.331L368.885 234.032L369.482 233.733L370.079 233.435L370.676 233.136L371.273 232.837H372.169H373.065H373.961H374.857H375.753H376.648H377.544H378.44H379.336H380.232H381.128H382.023H382.919H383.815H384.711H385.607H386.503H387.398H388.294H389.19H390.086H390.982H391.878H392.773H393.669H394.565H395.461H396.357H397.253H398.148H399.044H399.94H400.537H401.134H401.732H402.329H402.926H403.523H404.121H404.718H405.614H408.898V228.956Z",
    fill: "#B9B2B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.853 275.24V142.358L306.18 139.073V271.955L311.853 275.24Z",
    fill: "#CDC4C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.852 275.24V142.358L321.706 136.685V269.865L311.852 275.24Z",
    fill: "url(#paint0_linear_1509_12467)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.39 214.921H416.668L410.695 211.636L420.251 205.963H437.272L443.244 209.247L433.39 214.921Z",
    fill: "#B9B2B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.668 214.921V112.497L426.224 106.824V209.247L416.668 214.921Z",
    fill: "url(#paint1_linear_1509_12467)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.847 285.094L289.152 271.955V277.927L311.847 291.365V285.094Z",
    fill: "#C4B9BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.852 291.365V285.094L443.24 209.247V215.518L311.852 291.365Z",
    fill: "url(#paint2_linear_1509_12467)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.627 204.768L368.891 196.705V202.379L382.627 210.441V204.768Z",
    fill: "url(#paint3_linear_1509_12467)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.01 233.734L328.273 225.671L368.885 202.379L382.621 210.442L342.01 233.734Z",
    fill: "#B9B2B4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.016 262.699V244.483V233.733V222.685L360.828 211.636V222.983L382.627 210.442V204.768L367.995 213.129V197.601L386.21 187.15V202.678V208.351V237.018L382.627 239.108L342.016 262.699Z",
    fill: "url(#paint4_linear_1509_12467)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.01 222.684L328.273 214.622V254.636L342.01 262.698V222.684Z",
    fill: "#C4B9BC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.986 197.601L354.25 189.837V205.365L367.986 213.129V197.601Z",
    fill: "url(#paint5_linear_1509_12467)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.986 197.602L354.25 189.838L372.465 179.088L386.201 187.15L367.986 197.602Z",
    fill: "#F4EEEE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.992 213.129V197.601L386.207 187.15V202.678L367.992 213.129Z",
    fill: "url(#paint6_linear_1509_12467)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.672 209.546V198.497L383.512 191.032V202.081L370.672 209.546Z",
    fill: "#323035"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.473 206.859V198.796L381.73 193.421V201.484L372.473 206.859Z",
    fill: "#4D4047"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.01 222.685L328.273 214.622L346.489 204.171L360.225 212.233L342.01 222.685Z",
    fill: "#F4EEEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.01 222.685L328.273 214.622L346.489 204.171L360.225 212.233L342.01 222.685Z",
    fill: "#B9B2B4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.77 220.893L353.054 218.803V253.143L349.77 255.233V220.893Z",
    fill: "#4D4047"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.551 218.205L357.835 216.115V250.455L354.551 252.546V218.205Z",
    fill: "#4D4047"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.551 218.205L357.835 216.115V239.705L354.551 241.796V218.205Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.551 242.691L357.835 240.601V250.455L354.551 252.545V242.691Z",
    fill: "#00605F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.946 223.581C356.946 223.581 356.946 228.06 358.439 230.449C359.335 231.643 360.231 234.331 360.231 236.72C360.231 237.616 360.231 238.511 359.932 239.109C359.634 240.004 359.036 240.303 358.141 240.602C357.543 240.9 356.349 240.602 355.453 240.004L356.05 238.81C356.946 239.109 357.543 239.407 358.141 239.109C358.439 239.109 358.738 238.81 359.036 238.213C359.335 237.616 359.335 237.018 359.335 236.421C359.335 234.331 358.439 232.24 357.842 231.046C356.05 228.06 356.05 223.282 356.05 223.282H356.946V223.581Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.05 218.504L356.648 218.206C356.946 217.907 357.245 218.206 357.245 218.504V221.192C357.245 221.49 356.946 221.789 356.648 222.088L356.05 222.386C355.752 222.685 355.453 222.386 355.453 222.088V219.4C355.453 219.101 355.752 218.803 356.05 218.504Z",
    fill: "#004141"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.742 220.594L356.638 219.997C356.936 219.698 357.235 219.997 357.235 220.295V223.879C357.235 224.177 356.936 224.775 356.638 225.073L355.742 225.67C355.443 225.969 355.145 225.67 355.145 225.372V221.789C355.145 221.49 355.443 220.893 355.742 220.594Z",
    fill: "#00605F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.349 222.685C356.648 222.386 357.245 222.685 357.245 223.282C357.245 223.879 356.946 224.476 356.349 224.775C356.05 225.074 355.453 224.775 355.453 224.178C355.453 223.581 355.752 222.983 356.349 222.685Z",
    fill: "#323035"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.77 220.893L353.054 218.803V242.393L349.77 244.483V220.893Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.77 245.379L353.054 243.289V253.143L349.77 255.233V245.379Z",
    fill: "#A5672F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.161 226.268C352.161 226.268 352.161 230.747 353.654 233.136C354.55 234.33 355.446 237.018 355.446 239.407C355.446 240.303 355.446 241.198 355.147 241.796C354.849 242.692 354.251 242.99 353.355 243.289C352.758 243.587 351.564 243.289 350.668 242.692L351.265 241.497C352.161 241.796 352.758 242.094 353.355 241.796C353.654 241.796 353.953 241.497 354.251 240.9C354.55 240.303 354.55 239.705 354.55 239.108C354.55 237.018 353.654 234.928 353.057 233.733C351.265 230.747 351.265 225.969 351.265 225.969H352.161V226.268Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.265 221.49L351.862 221.192C352.161 220.893 352.46 221.192 352.46 221.49V224.178C352.46 224.477 352.161 224.775 351.862 225.074L351.265 225.372C350.967 225.671 350.668 225.372 350.668 225.074V222.386C350.668 222.088 350.967 221.49 351.265 221.49Z",
    fill: "#8E5223"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.961 223.282L351.856 222.685C352.155 222.386 352.454 222.685 352.454 222.983V226.567C352.454 226.865 352.155 227.463 351.856 227.761L350.961 228.358C350.662 228.657 350.363 228.358 350.363 228.06V224.477C350.363 224.178 350.662 223.581 350.961 223.282Z",
    fill: "#A5672F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.564 225.372C351.862 225.073 352.46 225.372 352.46 225.969C352.46 226.566 352.161 227.164 351.564 227.462C351.265 227.761 350.668 227.462 350.668 226.865C350.668 226.268 350.967 225.671 351.564 225.372Z",
    fill: "#323035"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345 223.581L348.583 221.49V245.081L345 247.171V223.581Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345 248.067L348.583 246.275V255.831L345 257.921V248.067Z",
    fill: "#48602B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.38 229.254C347.38 229.254 347.38 233.733 348.873 236.122C349.769 237.317 350.665 240.004 350.665 242.393C350.665 243.289 350.664 244.185 350.366 244.782C350.067 245.678 349.47 245.976 348.574 246.275C347.977 246.574 346.783 246.275 345.887 245.678L346.484 244.483C347.38 244.782 347.977 245.081 348.574 244.782C348.873 244.782 349.171 244.483 349.47 243.886C349.769 243.289 349.769 242.692 349.769 242.094C349.769 240.004 348.873 237.914 348.276 236.719C346.484 233.733 346.484 228.956 346.484 228.956H347.38V229.254Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.484 224.178L347.081 223.879C347.38 223.58 347.678 223.879 347.678 224.178V226.865C347.678 227.164 347.38 227.462 347.081 227.761L346.484 228.059C346.185 228.358 345.887 228.059 345.887 227.761V225.073C345.887 224.775 346.185 224.178 346.484 224.178Z",
    fill: "#354D22"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.191 226.268L347.087 225.671C347.385 225.372 347.684 225.671 347.684 225.969V229.553C347.684 229.851 347.385 230.449 347.087 230.747L346.191 231.344C345.892 231.643 345.594 231.344 345.594 231.046V227.463C345.594 226.865 345.892 226.268 346.191 226.268Z",
    fill: "#48602B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.783 228.059C347.081 227.761 347.678 228.059 347.678 228.657C347.678 229.254 347.38 229.851 346.783 230.15C346.484 230.448 345.887 230.15 345.887 229.552C345.887 228.955 346.185 228.358 346.783 228.059Z",
    fill: "#323035"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.141 230.747L337.829 235.227C339.322 237.616 339.322 240.303 337.829 241.199C336.336 242.095 333.947 240.602 332.753 238.213C331.26 235.824 331.26 233.136 332.753 232.241L335.141 230.747Z",
    fill: "#E6943D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.147 232.24L336.939 235.525C337.835 237.317 337.835 239.108 336.939 239.706C336.043 240.303 334.251 239.407 333.355 237.615C332.46 235.824 332.46 234.032 333.355 233.435L335.147 232.24Z",
    fill: "#F7BC64"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.273 235.824L330.961 237.317C331.26 237.914 331.558 238.511 331.857 238.81C333.648 242.094 336.933 243.886 338.725 242.692C339.023 242.393 339.322 242.393 339.621 242.094L342.308 243.587V262.4L328.572 254.337V235.824H328.273Z",
    fill: "#F7BC64"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.01 242.094L339.919 240.9C339.919 240.601 339.919 240.302 339.919 240.004L342.01 241.198V242.094ZM328.273 233.136V234.032L330.364 235.226C330.364 234.927 330.364 234.629 330.364 234.33L328.273 233.136Z",
    fill: "#E6943D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.668 214.921V82.039L410.695 78.4557V211.636L416.668 214.921Z",
    fill: "#CDC4C6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.01 222.685L328.273 214.622L331.857 212.532L345.891 220.594L342.01 222.685Z",
    fill: "#F4EEEE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.882 356.164L412.188 343.025L543.278 267.178L565.972 280.317L434.882 356.164Z",
    fill: "#F4EEEE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.027 310.775L543.277 267.178L565.972 280.317L491.02 323.914L468.027 310.775Z",
    fill: "#B9B2B4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.429 337.351L451.901 346.31H434.881L429.207 343.025L438.763 337.351H467.429Z",
    fill: "#B9B2B4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.922 300.025L473.991 333.47C471.005 333.47 468.019 333.47 465.033 333.47L451.297 325.407L452.491 324.81L453.686 324.213L454.88 323.615L456.075 323.018L457.269 322.421L458.464 321.824L459.658 321.227L460.852 320.629L462.047 320.032L463.241 319.435L464.436 318.838L465.63 318.24L466.825 317.643L468.019 317.046L469.214 316.449L470.408 315.852L471.602 315.254L472.797 314.657L473.991 314.06L475.186 313.463L476.38 312.865L477.575 312.268L478.769 311.671L479.964 311.074L481.158 310.477L482.352 309.879L483.547 309.282L484.741 308.685L485.936 308.088L487.13 307.49L488.325 306.893L489.519 306.296L490.116 305.997L490.713 305.699L491.311 305.4L491.908 305.102L492.505 304.803L493.102 304.504L493.7 304.206L494.297 303.907H495.193H496.088H496.984H497.88H498.776H499.672H500.568H501.464H502.359H503.255H504.151H505.047H505.943H506.839H507.734H508.63H509.526H510.422H511.318H512.214H513.109H514.005H514.901H515.797H516.693H517.588H518.484H519.38H520.276H521.172H522.068H522.963H523.561H524.158H524.755H525.352H525.95H526.547H527.144H527.741H528.637H531.922V300.025Z",
    fill: "#B9B2B4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.881 346.31V213.428L429.207 209.845V343.025L434.881 346.31Z",
    fill: "#CDC4C6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.875 346.31V213.428L444.431 207.754V340.935L434.875 346.31Z",
    fill: "url(#paint7_linear_1509_12467)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.413 285.991H539.691L533.719 282.706L543.274 277.032H560.295L565.969 280.317L556.413 285.991Z",
    fill: "#B9B2B4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.695 285.99V183.268L549.251 177.893V280.316L539.695 285.99Z",
    fill: "url(#paint8_linear_1509_12467)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.882 356.164L412.188 343.025V348.997L434.882 362.136V356.164Z",
    fill: "#C4B9BC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.875 362.136V356.164L565.965 280.316V286.587L434.875 362.136Z",
    fill: "url(#paint9_linear_1509_12467)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.654 275.837L491.918 267.775V273.448L505.654 281.212V275.837Z",
    fill: "url(#paint10_linear_1509_12467)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.033 304.802L451.297 296.74L491.908 273.448L505.644 281.212L465.033 304.802Z",
    fill: "#B9B2B4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.039 333.469V315.553V304.803V293.754L483.852 282.706V293.754L505.65 281.213V275.838L491.018 284.199V268.671L509.233 258.219V273.747V279.122V308.088L505.65 310.178L465.039 333.469Z",
    fill: "url(#paint11_linear_1509_12467)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.033 293.754L451.297 285.692V325.705L465.033 333.469V293.754Z",
    fill: "#C4B9BC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.01 268.671L477.273 260.907V276.434L491.01 284.198V268.671Z",
    fill: "url(#paint12_linear_1509_12467)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.01 268.671L477.273 260.907L495.489 250.157L509.225 258.22L491.01 268.671Z",
    fill: "#F4EEEE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.02 284.199V268.671L509.235 258.219V273.747L491.02 284.199Z",
    fill: "url(#paint13_linear_1509_12467)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.406 280.615V269.567L506.545 261.803V272.851L493.406 280.615Z",
    fill: "#323035"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.191 277.927V269.865L504.747 264.49V272.552L495.191 277.927Z",
    fill: "#4D4047"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.033 293.754L451.297 285.692L469.512 275.24L483.248 283.004L465.033 293.754Z",
    fill: "#F4EEEE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.033 293.754L451.297 285.692L469.512 275.24L483.248 283.004L465.033 293.754Z",
    fill: "#B9B2B4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.793 291.962L476.078 289.872V324.212L472.793 326.302V291.962Z",
    fill: "#4D4047"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.574 288.976L480.859 287.185V321.525L477.574 323.317V288.976Z",
    fill: "#4D4047"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.574 288.976L480.859 287.185V310.775L477.574 312.567V288.976Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.574 313.761L480.859 311.671V321.525L477.574 323.317V313.761Z",
    fill: "#00605F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.966 294.65C479.966 294.65 479.966 299.129 481.459 301.518C482.355 302.712 483.25 305.4 483.25 307.789C483.25 308.684 483.25 309.58 482.952 310.177C482.653 311.073 482.056 311.372 481.16 311.671C480.563 311.969 479.368 311.671 478.473 311.073L479.07 309.879C479.966 310.178 480.563 310.476 481.16 310.177C481.459 310.177 481.757 309.879 482.056 309.282C482.355 308.684 482.355 308.087 482.355 307.49C482.355 305.4 481.459 303.309 480.862 302.115C479.07 299.129 479.07 294.351 479.07 294.351H479.966V294.65Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.07 289.574L479.667 289.275C479.966 288.977 480.264 289.275 480.264 289.574V292.261C480.264 292.56 479.966 292.859 479.667 293.157L479.07 293.456C478.771 293.754 478.473 293.456 478.473 293.157V290.47C478.473 290.171 478.771 289.872 479.07 289.574Z",
    fill: "#004141"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.769 291.664L479.665 291.067C479.964 290.768 480.262 291.066 480.262 291.365V294.948C480.262 295.247 479.964 295.844 479.665 296.143L478.769 296.74C478.47 297.039 478.172 296.74 478.172 296.442V292.858C478.172 292.261 478.47 291.962 478.769 291.664Z",
    fill: "#00605F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.368 293.754C479.667 293.455 480.264 293.754 480.264 294.351C480.264 294.948 479.966 295.545 479.368 295.844C479.07 296.143 478.473 295.844 478.473 295.247C478.473 294.65 478.771 294.052 479.368 293.754Z",
    fill: "#323035"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.793 291.962L476.078 289.872V313.462L472.793 315.552V291.962Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.793 316.449L476.078 314.359V324.213L472.793 326.303V316.449Z",
    fill: "#A5672F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.188 297.338C475.188 297.338 475.188 301.817 476.681 304.206C477.577 305.4 478.473 308.088 478.473 310.476C478.473 311.372 478.473 312.268 478.174 312.865C477.876 313.761 477.279 314.06 476.383 314.358C475.786 314.657 474.591 314.358 473.695 313.761L474.293 312.567C475.188 312.865 475.786 313.164 476.383 312.865C476.681 312.865 476.98 312.567 477.279 311.97C477.577 311.372 477.577 310.775 477.577 310.178C477.577 308.088 476.681 305.997 476.084 304.803C474.293 301.817 474.293 297.039 474.293 297.039H475.188V297.338Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.293 292.261L474.89 291.963C475.188 291.664 475.487 291.962 475.487 292.261V294.949C475.487 295.247 475.188 295.546 474.89 295.844L474.293 296.143C473.994 296.442 473.695 296.143 473.695 295.844V293.157C473.695 292.858 473.994 292.56 474.293 292.261Z",
    fill: "#8E5223"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474 294.352L474.895 293.754C475.194 293.456 475.493 293.755 475.493 294.053V297.636C475.493 297.935 475.194 298.532 474.895 298.831L474 299.428C473.701 299.727 473.402 299.428 473.402 299.129V295.546C473.402 295.248 473.701 294.65 474 294.352Z",
    fill: "#A5672F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.591 296.442C474.89 296.143 475.487 296.442 475.487 297.039C475.487 297.636 475.188 298.233 474.591 298.532C474.293 298.83 473.695 298.532 473.695 297.935C473.695 297.337 473.994 296.74 474.591 296.442Z",
    fill: "#323035"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.027 294.65L471.312 292.56V316.15L468.027 318.24V294.65Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.027 319.136L471.312 317.046V326.9L468.027 328.99V319.136Z",
    fill: "#48602B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.415 300.025C470.415 300.025 470.415 304.504 471.908 306.893C472.804 308.087 473.7 310.775 473.7 313.164C473.7 314.059 473.7 314.955 473.401 315.552C473.102 316.448 472.505 316.747 471.609 317.046C471.012 317.344 469.818 317.046 468.922 316.448L469.519 315.254C470.415 315.552 471.012 315.851 471.609 315.552C471.908 315.552 472.207 315.254 472.505 314.657C472.804 314.059 472.804 313.462 472.804 312.865C472.804 310.775 471.908 308.684 471.311 307.49C469.519 304.504 469.519 299.726 469.519 299.726H470.415V300.025Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.519 295.247L470.116 294.949C470.415 294.65 470.714 294.948 470.714 295.247V297.935C470.714 298.233 470.415 298.532 470.116 298.83L469.519 299.129C469.22 299.428 468.922 299.129 468.922 298.83V296.143C468.922 295.844 469.22 295.247 469.519 295.247Z",
    fill: "#354D22"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.218 297.039L470.114 296.442C470.413 296.143 470.711 296.442 470.711 296.74V300.324C470.711 300.622 470.413 301.219 470.114 301.518L469.218 302.115C468.92 302.414 468.621 302.115 468.621 301.817V298.233C468.621 297.935 468.92 297.337 469.218 297.039Z",
    fill: "#48602B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.818 299.129C470.116 298.83 470.714 299.129 470.714 299.726C470.714 300.323 470.415 300.921 469.818 301.219C469.519 301.518 468.922 301.219 468.922 300.622C468.922 300.025 469.22 299.427 469.818 299.129Z",
    fill: "#323035"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.169 301.816L460.856 306.296C462.349 308.684 462.349 311.372 460.856 312.268C459.363 313.164 456.974 311.671 455.78 309.282C454.287 306.893 454.287 304.205 455.78 303.309L458.169 301.816Z",
    fill: "#E6943D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.171 303.309L459.962 306.594C460.858 308.386 460.858 310.178 459.962 310.775C459.066 311.372 457.275 310.476 456.379 308.684C455.483 306.893 455.483 305.101 456.379 304.504L458.171 303.309Z",
    fill: "#F7BC64"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.297 306.893L453.984 308.386C454.283 308.984 454.582 309.581 454.88 309.879C456.672 313.164 459.957 314.956 461.748 313.761C462.047 313.463 462.345 313.463 462.644 313.164L465.332 314.657V333.47L451.596 325.407V306.893H451.297Z",
    fill: "#F7BC64"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.033 313.164L462.943 311.969C462.943 311.671 462.943 311.372 462.943 311.073L465.033 312.268V313.164ZM451.297 304.205V305.101L453.387 306.296C453.387 305.997 453.387 305.698 453.387 305.4L451.297 304.205Z",
    fill: "#E6943D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.691 285.99V152.809L533.719 149.525V282.705L539.691 285.99Z",
    fill: "url(#paint14_linear_1509_12467)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.033 293.754L451.297 285.692L454.88 283.601L468.616 291.664L465.033 293.754Z",
    fill: "#F4EEEE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.168 279.122L229.73 122.352L354.251 50.6848L625.39 207.157L501.168 279.122Z",
    fill: "#F4A856"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.303 142.955L625.386 207.157L509.525 274.344H501.164V142.955H514.303Z",
    fill: "url(#paint15_linear_1509_12467)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.17 274.344L617.031 207.157L354.253 55.462L238.094 122.351L501.17 274.344Z",
    fill: "#F4EEEE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.17 269.268L608.67 207.157L354.254 60.2402L246.754 122.351L501.17 269.268Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.168 279.122L229.73 122.351V128.622L501.168 285.095V279.122Z",
    fill: "#E6943D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.164 279.122L625.386 207.157V213.427L501.164 285.094V279.122Z",
    fill: "#9C3D21"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.166 274.345V252.248L238.688 100.852V122.65L501.166 274.345Z",
    fill: "#F7BC64"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.164 274.344V252.247L617.025 185.358V207.157L501.164 274.344Z",
    fill: "url(#paint16_linear_1509_12467)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.102 220.595L407.699 220.296L412.178 222.984L411.581 223.282L407.102 220.595Z",
    fill: "#9C3D21"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.178 216.115V222.684L407.698 219.997L406.504 217.011V194.316L410.983 197.004L411.58 198.497C412.178 198.497 412.476 198.198 413.073 198.198C413.671 198.198 414.566 198.497 415.462 199.094C417.254 199.99 418.448 201.483 419.344 203.573C419.344 203.872 419.643 204.17 419.643 204.469L420.837 207.754L421.136 208.65L421.434 209.545L421.733 210.441L422.032 211.337V212.233V213.129V214.025V214.92V215.816V216.712L421.733 217.309L421.434 217.907L421.136 218.504L420.837 219.101L420.539 219.4L419.941 219.698L419.344 219.997H418.747H418.15H417.552H416.955L416.358 219.698L415.761 219.4L415.462 219.101L415.164 218.802L414.865 218.504L414.566 218.205L414.268 217.907L413.969 217.608L413.671 217.309L413.372 217.011L413.073 216.712L412.775 216.414L412.476 216.115L412.178 215.816L411.879 215.518L411.58 215.219L412.178 216.115ZM416.059 206.559L415.761 206.261L415.462 205.962L415.164 205.663C414.566 205.066 413.969 205.066 413.073 204.768V211.039C413.372 211.039 413.372 211.337 413.671 211.337C414.865 211.934 415.462 211.934 416.059 211.636C416.657 211.038 416.955 210.143 416.955 208.351C416.059 207.455 416.059 206.858 416.059 206.559ZM437.261 230.448H436.962H436.664H436.365H436.066H435.768H435.469H435.171H434.872H434.573H434.275H433.976H433.678H433.379H433.08H432.782H432.483H432.184H431.886H431.587H431.289H430.99L430.691 230.15L429.796 229.552L428.9 228.955L428.004 228.358L427.108 227.761L426.212 226.865L425.615 225.969L425.018 225.073L424.421 224.177L423.823 223.282L423.525 222.386L423.226 221.49L422.032 218.504L421.733 218.205C421.136 216.712 420.837 214.92 420.837 213.129C420.837 210.441 421.434 208.65 422.928 207.754C424.421 206.858 426.212 207.157 428.601 208.65C430.691 209.844 432.483 211.636 433.678 213.726C434.573 215.219 435.171 217.011 435.768 218.504L436.066 219.4L436.365 220.295L436.664 221.191V222.087V222.983V223.879V225.67L435.469 225.073L436.365 227.761V230.448H437.261ZM435.171 222.983L427.705 218.802V219.101V219.4C428.004 219.997 428.601 220.295 429.198 220.893C429.796 221.191 430.393 221.789 430.99 222.087C431.587 222.386 431.886 222.684 432.483 222.684C433.08 222.983 433.379 222.983 433.976 222.983C434.275 222.983 434.573 222.983 435.171 222.983ZM431.886 214.92L431.587 214.323L431.289 214.025L430.99 213.726L430.691 213.427L430.393 213.129H430.094H429.796C429.497 213.129 429.198 213.129 428.9 213.129L432.184 215.219C431.886 215.219 431.886 214.92 431.886 214.92ZM448.907 238.212V234.629L447.712 231.344L447.414 231.045C447.115 231.045 447.115 231.045 446.518 231.045C446.219 231.045 445.921 230.747 445.622 230.747C445.323 230.448 445.025 230.448 444.726 230.15V229.851V229.552V229.254V228.955V228.657V228.358V222.386L449.205 224.775V221.191L448.011 217.907L445.025 216.115V214.025L443.83 210.74L439.351 208.052V212.83L437.559 211.934V215.518L438.754 218.802L439.351 219.101V224.476C439.351 225.969 439.65 227.164 439.948 228.358L441.143 231.643L441.441 232.24L441.74 232.837L442.039 233.434L442.337 234.032L442.636 234.629L443.233 235.226L443.83 235.525L444.427 235.823L445.025 236.122L445.622 236.42L445.921 236.719L446.219 237.018H446.518H446.816H447.115H447.414H447.712H448.011H448.309H448.608H448.907H449.205H449.504H449.802L448.907 238.212ZM459.955 232.837L459.657 232.539H459.358H459.059H458.761H458.462H458.164H457.865H457.566H457.268H456.969H456.671H456.372H456.073H455.775H455.476H455.177H454.879V243.587L450.4 240.9L449.205 237.615V220.893L453.684 223.58L454.58 225.67C454.879 225.67 455.177 225.372 455.476 225.372C455.775 225.372 456.073 225.372 456.671 225.372C456.969 225.372 457.566 225.67 457.865 225.969C457.865 225.969 458.164 226.268 458.462 226.268C458.761 226.268 458.761 226.566 459.059 226.566L460.254 229.851V231.643C460.552 230.747 461.15 230.448 461.747 229.851C462.941 228.955 465.032 229.254 467.122 230.747C469.511 232.24 471.302 234.032 472.497 236.42C472.796 237.018 473.094 237.615 473.393 238.212C473.393 238.511 473.393 238.511 473.691 238.809L474.587 241.497L474.886 242.393L475.184 243.289L475.483 244.184L475.782 245.08V245.976V246.872V247.768V248.664L475.483 249.559L475.184 250.157L474.886 250.754L474.587 251.351L474.289 251.65L473.691 251.948L473.094 252.247L472.497 252.545H471.9H471.302L470.705 252.247L469.809 251.948L468.914 251.65L468.018 251.052L467.122 250.455L466.226 249.858L465.33 249.261L464.733 248.664L464.136 248.066L463.539 247.17L462.941 246.275L462.344 245.379L461.747 244.483L461.448 243.587L460.254 240.302C459.657 238.511 459.059 236.42 459.059 234.629C459.955 233.434 459.955 233.136 459.955 232.837ZM470.108 237.316L469.809 237.018H469.511H469.212H468.914V237.316V237.615V237.914V238.212V238.511V238.809V239.108V239.407V239.705V240.004V240.302V240.601V240.9V241.198V241.497V241.795V242.094V242.393L469.212 242.691C469.511 242.99 470.108 243.289 470.407 243.587C470.705 243.886 471.004 243.886 471.601 243.886C471.9 243.886 472.198 243.886 472.497 243.587C472.796 243.289 473.094 242.99 473.094 242.393C473.094 241.795 473.393 241.198 473.393 240.004C470.407 238.809 470.108 238.212 470.108 237.316ZM482.948 257.92L478.469 255.233L477.275 251.948V228.955L481.754 231.643L482.948 234.927V257.92Z",
    fill: "#BB7A31"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.633 191.927L597.619 190.136V167.441L594.633 169.233V191.927Z",
    fill: "#A0969B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.158 168.337L593.144 166.546L592.846 166.247L592.547 165.65L592.249 165.351L591.95 165.053L591.651 164.754V164.455L591.353 164.157L591.054 163.858L590.756 163.56L590.457 163.261L590.158 162.962L589.86 162.664L589.561 162.365H589.263L588.964 162.067L588.665 161.768L588.068 161.469L587.471 161.171H586.874H586.276H585.978H585.381L582.395 162.962H582.992H583.29H583.888H584.485L585.082 163.261L585.679 163.56L585.978 163.858H586.276L586.575 164.157L586.874 164.455L587.172 164.754L587.471 165.053L587.769 165.351L588.068 165.65L588.367 165.949V166.247L588.665 166.546L588.964 166.844L589.263 167.143L589.561 167.442L589.86 168.039L590.158 168.337Z",
    fill: "#F4EEEE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.632 169.233L597.618 167.442L593.138 164.754L590.152 166.546L594.632 169.233Z",
    fill: "#F4EEEE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.148 179.386L593.135 177.594H592.836H592.537H592.239V177.296H591.94H591.641L591.343 176.997L590.746 176.698L590.447 176.4L590.148 176.101L589.85 175.802L589.551 175.504L589.253 175.205L588.954 174.608L588.655 174.309V173.712L588.357 173.414V172.816L588.058 172.518V171.921V171.323V170.726V170.129V169.532V168.934V168.636V168.039V167.74L588.357 167.441V167.143L588.655 166.844L585.669 168.636L585.371 168.934V169.233L585.072 169.532V169.83V170.129V170.726V171.323L584.773 171.921L585.072 172.518V173.115V173.712V174.011L585.371 174.608V175.205L585.669 175.504V176.101L585.968 176.4L586.266 176.698L586.565 177.296L586.864 177.594L587.162 177.893L587.461 178.191L587.76 178.49L588.058 178.789H588.357H588.655V179.087H588.954H589.253V179.386H589.551H589.85H590.148Z",
    fill: "#F4EEEE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.426 169.234L576.412 167.442H576.113L575.815 167.741H575.516L575.217 167.442H574.919H574.62H574.322V167.143H574.023H573.724L573.426 166.845L573.127 166.546H572.829L572.53 166.247H572.231V165.949H571.933L571.634 165.65L571.335 165.352H571.037V165.053H570.738V164.754L570.44 164.456L570.141 164.157L569.842 163.859L569.544 163.56L569.245 163.261V162.963H568.947V162.664L568.648 162.366L568.349 162.067L565.363 163.859L565.662 164.157V164.456H565.961V164.754H566.259V165.053L566.558 165.352L566.856 165.65V165.949H567.155V166.247H567.454L567.752 166.546L568.051 166.845V167.143H568.349L568.648 167.442L568.947 167.741H569.245V168.039H569.544L569.842 168.338H570.141L570.44 168.636H570.738L571.037 168.935H571.335L571.634 169.234H571.933H572.231H572.53H572.829H573.127H573.426Z",
    fill: "#F4EEEE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.367 163.858L568.353 162.067L567.756 161.768L564.77 163.56L565.367 163.858Z",
    fill: "#F4EEEE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.943 158.782V158.483L572.242 158.185V157.886V157.587V157.289L572.54 156.99L572.839 156.692L569.853 158.483H569.554V158.782L569.256 159.081V159.379V159.678L568.957 159.976V160.275V160.574L574.631 163.858L577.617 162.067L571.943 158.782Z",
    fill: "#A0969B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.713 173.713L579.699 171.921L580.296 171.622L580.894 171.324L581.192 170.726L581.491 170.129L581.789 169.532V168.636L582.088 167.74V166.844V165.949L581.789 164.754V163.858L581.491 162.963L581.192 162.067L580.894 161.171L580.595 159.976L579.998 159.081L579.401 158.185L578.803 157.588L578.206 156.692L577.609 156.094L576.713 155.199L576.116 154.601L575.22 154.004L574.324 153.407L573.428 153.108L572.831 152.81L571.935 152.511L571.338 152.213H570.741H570.144L569.845 152.511L569.248 152.81L566.262 154.303H566.859L567.158 154.004H567.755H568.352L568.949 154.303L569.845 154.601L570.442 154.9L571.338 155.199L572.234 155.796L573.13 156.393L573.727 156.99L574.623 157.588L575.22 158.483L575.817 159.379L576.415 159.976L577.012 160.872L577.31 161.768L577.908 162.664L578.206 163.858L578.505 164.754L578.803 165.65V166.546L579.102 167.74V168.636V169.532L578.803 170.428V171.324L578.505 171.921L578.206 172.518L577.908 173.115L577.31 173.414L576.713 173.713Z",
    fill: "url(#paint17_linear_1509_12467)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.887 165.351L563.873 163.56H564.171L564.47 163.261V162.963L564.769 162.365V162.067L565.067 161.469V160.872V159.976V152.213L562.081 154.004V161.768V162.664V163.261L561.783 163.56V164.157L561.484 164.456L561.185 165.053L560.887 165.351Z",
    fill: "#A0969B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.871 154.9L566.857 153.406V149.525L563.871 151.316V154.9Z",
    fill: "#A0969B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.881 151.317L566.868 149.525L565.076 148.629L562.09 150.421L563.881 151.317Z",
    fill: "#F4EEEE"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.09 150.421L565.076 148.629V143.851L562.09 145.643V150.421Z",
    fill: "#A0969B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.085 145.643L565.071 143.852L560.592 141.164L557.605 142.956L562.085 145.643Z",
    fill: "#F4EEEE"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.332 160.873L554.318 159.081V142.657L551.332 144.15V160.873Z",
    fill: "#A0969B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.011 160.275L559.997 158.483H559.699H559.4H559.102H558.803L558.504 158.185H558.206V157.886H557.907L557.609 157.587L557.31 157.289L557.011 156.99H556.713V156.692L553.727 158.483L554.025 158.782V159.081H554.324L554.622 159.379L554.921 159.678H555.22V159.976H555.518L555.817 160.275H556.115H556.414H556.713H557.011Z",
    fill: "#F4EEEE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.726 158.483L556.712 156.691L556.115 156.393L553.129 158.185L553.726 158.483Z",
    fill: "#F4EEEE"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.608 147.733L560.594 145.941L556.115 143.552L553.129 145.344L557.608 147.733Z",
    fill: "#F4EEEE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.084 151.914L542.07 150.122L542.667 149.823L542.966 149.525L543.264 148.928L543.563 148.33L543.862 147.435V146.837L544.16 145.941V144.747V143.851L543.862 142.955V141.761L543.563 140.865L543.264 139.969L542.966 139.073L542.667 138.178L542.07 137.282L541.473 136.386L540.875 135.49L540.278 134.893L539.681 133.997L539.084 133.4L538.188 132.803L537.591 132.205L536.695 131.608L535.799 131.31L534.903 131.011L534.306 130.712L533.41 130.414H532.813H532.216L531.619 130.712L531.021 131.011L528.035 132.504H528.632L529.23 132.205H529.827H530.424L531.021 132.504H531.917L532.813 133.101L533.709 133.4L534.306 133.997L535.202 134.594L536.098 135.191L536.695 135.789L537.292 136.685L537.889 137.282L538.487 138.178L539.084 139.073L539.382 139.969L539.98 140.865L540.278 141.761L540.577 142.657L540.875 143.553V144.448V145.643L541.174 146.539L540.875 147.733V148.629V149.226L540.577 150.122L540.278 150.719L539.98 151.018L539.382 151.615L539.084 151.914Z",
    fill: "url(#paint18_linear_1509_12467)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.858 144.15L549.844 142.358V142.06L549.545 141.761V141.462H549.247V141.164L548.948 140.865V140.567L548.649 140.268L548.351 139.969L548.052 139.671V139.372H547.753V139.073H547.455V138.775H547.156V138.476H546.858V138.178H546.559V137.879H546.26V137.58H545.962L545.663 137.282H545.365H545.066V136.983H544.767L541.781 138.775H542.08L542.378 139.073H542.677V139.372H542.976L543.274 139.671L543.573 139.969H543.872L544.17 140.268V140.567H544.469V140.865H544.767V141.164H545.066V141.462L545.365 141.761L545.663 142.06V142.358L545.962 142.657L546.26 142.955V143.254H546.559V143.553L546.858 143.851V144.15Z",
    fill: "url(#paint19_linear_1509_12467)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.335 144.15L554.321 142.657L549.842 139.969L546.855 141.761L551.335 144.15Z",
    fill: "#F4EEEE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.508 147.734L538.494 145.942H538.196H537.897H537.599H537.3H537.001L536.703 145.643H536.404V145.345H536.105L535.807 145.046L535.508 144.747L535.21 144.449V144.15H534.911V143.852H534.612V143.553V143.254L534.314 142.956V142.657L534.015 142.359V142.06V141.761V141.463V141.164V140.866L533.717 140.567V140.268V139.97V139.671V139.372V139.074V138.477V138.178V137.879V137.581V137.282L534.015 136.984V136.685V136.386V136.088L534.314 135.789V135.491H534.612V135.192H534.911L531.925 136.984H531.626L531.328 137.282V137.581L531.029 137.879V138.178V138.477L530.73 138.775V139.074V139.372V139.671V139.97V140.268V140.567V141.164V141.463V141.761V142.06V142.359V142.657L531.029 142.956V143.254V143.553V143.852V144.15H531.328V144.449V144.747V145.046H531.626V145.345V145.643H531.925V145.942L532.224 146.241L532.522 146.539L532.821 146.838L533.119 147.136H533.418V147.435H533.717L534.015 147.734H534.314H534.612H534.911H535.21H535.508Z",
    fill: "#F4EEEE"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.863 145.046L526.849 143.254V120.261L523.863 121.754V145.046Z",
    fill: "#A0969B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.862 121.754L526.848 120.261L522.369 117.573L519.383 119.365L523.862 121.754Z",
    fill: "#F4EEEE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.299 168.935C580.299 171.622 580.897 174.011 582.091 176.4C583.286 178.789 584.779 180.282 586.57 181.476C587.167 181.775 588.063 182.074 588.362 182.372C588.959 182.372 589.556 182.671 590.154 182.372V189.24L594.633 191.928V169.233L590.154 166.546V168.337C589.556 167.442 588.959 166.247 588.063 165.65C587.466 164.754 586.57 164.157 585.674 163.56C583.883 162.664 582.688 162.664 581.792 163.56C580.897 164.754 580.299 166.546 580.299 168.935ZM584.779 171.921C584.779 170.428 585.077 169.233 585.376 168.636C585.674 168.039 586.57 168.039 587.466 168.636C587.765 168.935 588.362 169.233 588.661 169.532C588.959 169.831 589.556 170.428 589.855 171.025V179.386C589.556 179.386 589.258 179.386 588.959 179.087C588.661 179.087 588.362 178.789 588.063 178.49C586.869 177.893 586.272 176.997 585.674 175.803C585.077 174.907 584.779 173.414 584.779 171.921ZM570.445 172.518C573.133 174.011 575.223 174.608 576.716 174.011C578.209 173.414 578.806 171.622 578.806 168.935C578.806 166.247 578.209 163.56 576.716 161.171C575.223 158.782 573.431 156.99 571.042 155.497C568.952 154.303 567.161 154.004 565.966 154.601C564.772 155.199 564.174 156.99 564.174 159.678V161.469L574.029 167.143C574.029 168.039 573.73 168.337 573.73 168.935C573.431 169.233 573.133 169.532 572.834 169.532C572.536 169.532 571.938 169.532 571.341 169.532C570.744 169.233 570.147 169.233 569.549 168.636C568.952 168.337 568.654 168.039 568.056 167.442C567.459 167.143 567.161 166.546 566.563 166.247C566.265 165.949 565.966 165.351 565.667 165.053C565.369 164.754 565.07 164.456 564.772 164.157L564.174 163.858V168.039C564.473 168.337 564.772 168.636 565.07 169.233C565.369 169.532 565.667 169.831 566.265 170.428C566.862 170.726 567.161 171.324 567.758 171.622C569.251 171.622 569.848 171.921 570.445 172.518ZM568.952 160.574C568.952 159.379 569.251 158.782 569.549 158.483C569.848 158.185 570.744 158.185 571.341 158.782C572.237 159.379 572.834 159.976 573.431 160.872C574.029 161.768 574.327 162.664 574.327 163.858L568.952 160.574ZM556.709 164.456C558.501 165.65 559.994 165.949 560.591 165.351C561.487 165.053 561.786 163.858 561.786 161.768V154.004L563.577 154.9V151.317L561.786 150.421V145.643L557.306 142.955V147.733L552.827 145.344V148.928L557.306 151.317V157.289C557.306 157.886 557.306 158.483 557.306 158.782C557.306 159.081 557.306 159.678 557.008 159.976C557.008 160.275 556.709 160.275 556.411 160.574C556.112 160.574 555.515 160.574 555.216 159.976C554.917 159.976 554.619 159.678 554.32 159.379C554.022 159.081 553.723 158.782 553.424 158.483L553.126 158.185V161.768C553.723 162.067 554.022 162.664 554.619 162.962C555.216 163.56 556.112 163.858 556.709 164.456ZM541.779 143.553L542.077 143.851C542.376 143.851 542.376 143.851 542.973 144.15C543.272 144.449 543.57 144.449 544.168 144.747C544.765 145.046 545.063 145.344 545.661 145.942C546.258 146.539 546.556 146.837 547.154 147.435V158.483L551.633 161.171V144.449L547.154 141.761V144.15C546.855 143.851 546.556 143.254 546.258 142.955C545.959 142.358 545.661 142.06 545.362 141.462C545.063 141.164 544.765 140.567 544.168 140.268C543.869 139.969 543.272 139.671 542.973 139.372C542.973 139.372 542.674 139.074 542.376 139.074C542.077 139.074 542.077 138.775 541.779 138.775V143.553ZM526.251 137.879C526.251 140.567 526.848 143.254 528.341 145.344C529.536 147.733 531.626 149.525 533.716 151.018C536.105 152.511 537.897 152.511 539.091 151.914C540.286 151.018 541.181 149.226 541.181 146.539C541.181 143.851 540.584 141.164 539.091 138.775C537.897 136.386 535.806 134.594 533.716 133.4C531.327 131.907 529.536 131.907 528.341 132.504C526.848 133.4 526.251 135.192 526.251 137.879ZM530.73 140.567C530.73 139.671 530.73 138.775 531.029 138.178C531.029 137.581 531.327 137.282 531.626 136.983C531.924 136.685 532.223 136.685 532.522 136.685C532.82 136.685 533.119 136.983 533.716 136.983C534.015 137.282 534.612 137.581 534.911 137.879C535.209 138.178 535.508 138.775 535.806 139.372C536.105 139.969 536.404 140.567 536.404 141.164C536.702 142.06 536.702 142.956 536.702 143.851C536.702 144.747 536.702 145.643 536.404 146.24C536.404 146.837 536.105 147.136 535.806 147.435C535.508 147.733 535.209 147.733 534.911 147.733C534.612 147.733 534.015 147.435 533.716 147.435C533.418 147.136 533.119 146.837 532.522 146.539C532.223 146.24 531.924 145.643 531.626 145.344C531.327 144.747 531.029 144.15 531.029 143.553C530.73 142.657 530.73 141.761 530.73 140.567ZM519.383 142.358L523.862 145.046V122.053L519.383 119.365V142.358Z",
    fill: "url(#paint20_linear_1509_12467)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.688 100.852L501.166 252.247L617.027 185.359L354.549 33.6641L238.688 100.852Z",
    fill: "#FDE182"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.47 239.109L482.95 241.796H484.443C486.234 241.796 488.325 241.796 490.116 241.796L493.102 240.004L492.505 239.706L491.908 239.407L491.311 239.109L490.713 238.81L490.116 238.511L489.519 238.213L488.922 237.914L488.325 237.616H487.727H487.13H486.533H485.936H485.339H484.741H483.547H482.95H482.352H481.755H481.158H480.561H479.964H479.366H478.769H478.172L477.276 238.213L478.47 239.109ZM405.609 197.004L406.505 196.407H406.804H407.102H407.401H407.7H407.998H408.297H408.595H408.894H409.193H409.491H409.79H410.089H410.387H410.686H410.984H411.283L411.88 196.706L412.477 197.004L413.075 197.303L413.672 197.602L414.269 197.9L414.866 198.199L415.464 198.498L416.061 198.796L415.464 199.095H415.762H416.359H416.658H416.957H417.255H417.554L417.852 199.393L418.151 199.692L418.45 199.991L418.748 200.289L419.047 200.588L419.345 200.886L419.644 201.185L419.943 201.484L420.54 201.782L421.137 202.081L421.436 202.379L421.734 202.678V202.977V203.275V203.574L421.436 203.873L419.345 205.067L419.047 204.768L413.075 201.484L411.582 200.588L410.984 200.289L407.102 197.9L405.609 197.004ZM426.811 209.248L430.991 211.636L434.873 213.727L435.47 214.025L437.561 212.831V212.532V212.234L437.262 211.935L436.964 211.636L436.665 211.338L436.068 211.039L435.47 210.741L434.575 210.143L433.679 209.546L432.783 208.949L431.887 208.352L430.991 208.053L430.095 207.754L428.901 207.456L427.707 207.157L426.512 206.859H426.214H425.915H425.616H425.318H425.019H424.72H424.422H424.123H423.825H423.526H423.227H422.929H422.63H422.332H422.033H421.734L420.839 207.456L426.811 209.248ZM438.755 216.116L438.158 215.817L436.964 215.22L438.457 214.324H438.755H439.054H439.352H439.651H439.95H440.248H440.547H440.845H441.144H441.443H441.741H442.04H442.339H442.637H442.936H443.234H443.533H443.832H444.13H444.429H444.727H445.026H445.325H445.623H445.922H446.22H446.519H446.818H447.116H447.415H447.714H448.012H448.311H448.609H448.908H449.207H449.505H449.804H450.102H450.401L450.998 214.623L451.595 214.921L452.193 215.22L452.79 215.518L453.387 215.817L453.984 216.116L454.582 216.414L455.179 216.713L452.79 218.206L453.089 218.504L453.686 218.803L454.283 219.102L454.88 219.4L453.089 220.296H453.387H453.686H453.984H454.283H454.582H454.88H455.179H455.477H455.776H456.075H456.373H456.672L457.269 220.595L457.866 220.893L458.464 221.192L459.061 221.491L459.658 221.789L460.255 222.088L460.852 222.386L461.45 222.685L460.554 223.282H460.852H461.151H461.45H461.748H462.047H462.345H462.644H462.943H463.241H463.54H463.838H464.137H464.436H464.734H465.033H465.332H465.63H465.929H466.227H466.526H466.825H467.123H467.422H467.72L465.929 224.178H466.227H466.526H466.825H467.123H467.422H467.72H468.019H468.318H468.616L469.811 224.477L470.707 224.775L471.602 225.074L472.498 225.373L473.394 225.671L474.29 225.97L475.186 226.567L476.082 227.164L476.977 227.761L477.575 228.359L478.172 228.657L478.769 228.956L479.068 229.254L479.366 229.553V229.852V230.15L477.575 231.046L476.679 230.449L472.797 228.359L468.616 225.97L464.436 223.581L463.241 222.984L461.151 221.789L459.061 220.595L458.165 219.998L454.582 217.907L452.79 217.011L452.491 216.713L438.755 216.116Z",
    fill: "url(#paint21_linear_1509_12467)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.707 100.851L501.165 242.393L600.005 185.358L354.547 43.5176L255.707 100.851Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.165 242.393L600.005 185.358L354.547 43.5176L255.707 100.851L501.165 242.393Z",
    fill: "url(#paint22_linear_1509_12467)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.106 197.601L600.009 185.358L354.551 43.5176L370.974 86.219L579.106 197.601Z",
    fill: "#DE9931"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.163 242.393L588.955 191.928L354.546 56.657L266.754 107.122L501.163 242.393Z",
    fill: "#F4EEEE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.323 111.004L361.115 60.2403L354.546 56.657L266.754 107.122L273.323 111.004Z",
    fill: "#A69CA0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.548 210.74C420.548 213.427 419.951 215.219 418.756 216.115C417.562 217.011 416.069 217.011 414.277 216.115C413.68 215.816 412.784 215.219 412.486 214.622C411.888 214.025 411.291 213.427 410.694 212.83V219.698L406.215 217.011V194.316L410.694 197.004V198.795C411.291 198.497 411.888 198.497 412.784 198.497C413.381 198.497 414.277 198.795 415.173 199.393C416.965 200.288 418.159 201.782 419.055 203.872C420.25 205.664 420.548 208.052 420.548 210.74ZM416.069 208.351C416.069 206.858 415.77 205.365 415.472 204.469C415.173 203.573 414.277 202.677 413.381 202.08C413.083 201.782 412.486 201.782 412.187 201.483C411.888 201.483 411.291 201.483 410.993 201.483V209.844C411.291 210.143 411.59 210.441 411.888 210.441C412.187 210.74 412.486 210.74 412.784 211.039C413.979 211.636 414.576 211.636 415.173 211.337C415.77 211.039 416.069 209.844 416.069 208.351ZM430.402 225.372C427.715 223.879 425.625 221.789 424.131 219.4C422.638 217.011 422.041 214.622 422.041 211.636C422.041 208.948 422.638 207.157 424.131 206.261C425.625 205.365 427.416 205.663 429.805 207.157C431.895 208.351 433.687 210.143 434.881 212.233C436.076 214.323 436.673 216.413 436.673 219.101V220.893L426.819 215.219C426.819 216.115 427.118 216.712 427.118 217.309C427.416 217.907 427.715 218.504 428.013 219.101C428.312 219.698 428.909 219.997 429.506 220.594C430.104 220.893 430.701 221.49 431.298 221.789C431.895 222.087 432.194 222.386 432.791 222.386C433.388 222.684 433.687 222.684 434.284 222.684C434.583 222.684 434.881 222.684 435.18 222.684C435.479 222.684 435.777 222.684 436.076 222.684L436.673 222.983V227.164C436.375 227.164 436.076 227.164 435.777 227.164C435.479 227.164 435.18 227.164 434.583 226.865C433.986 226.865 433.687 226.566 433.09 226.268C431.895 226.268 431.298 225.969 430.402 225.372ZM431.895 215.518C431.895 214.323 431.597 213.427 431.298 212.532C431 211.636 430.104 211.039 429.506 210.441C428.611 209.844 428.013 209.844 427.416 210.143C426.819 210.441 426.52 211.039 426.52 212.233L431.895 215.518ZM444.138 233.136C442.347 231.941 440.854 230.747 440.256 229.552C439.361 228.059 439.062 226.566 439.062 224.476V216.712L437.27 215.816V212.233L439.062 213.129V208.351L443.541 211.039V215.816L448.02 218.205V221.789L443.541 219.4V225.372C443.541 225.969 443.541 226.566 443.541 226.865C443.541 227.164 443.541 227.761 443.84 228.059C443.84 228.358 444.138 228.955 444.437 229.254C444.736 229.552 445.333 229.851 445.631 230.448C445.93 230.448 446.229 230.747 446.527 230.747C446.826 230.747 447.124 231.045 447.423 230.747L447.722 231.045V234.629C447.125 234.629 446.826 234.33 446.229 234.032C445.631 234.032 445.034 233.733 444.138 233.136ZM459.368 229.851L459.069 229.552C458.77 229.254 458.77 229.254 458.173 228.955C457.874 228.657 457.576 228.657 456.979 228.358C456.381 228.059 456.083 227.761 455.486 227.761C454.888 227.761 454.59 227.462 453.993 227.462V238.511L449.513 235.823V219.101L453.993 221.789V224.177C454.291 224.177 454.59 223.879 454.888 223.879C455.187 223.879 455.486 223.58 455.784 223.58C456.083 223.58 456.381 223.58 456.979 223.58C457.277 223.58 457.874 223.879 458.173 224.177C458.173 224.177 458.472 224.476 458.77 224.476C459.069 224.476 459.069 224.775 459.368 224.775V229.851ZM474.895 242.393C474.895 245.08 474.298 246.872 472.805 247.768C471.611 248.664 469.52 248.365 467.43 246.872C465.041 245.379 463.25 243.587 462.055 241.198C460.861 238.809 459.965 236.42 459.965 233.733C459.965 231.045 460.562 229.254 462.055 228.358C463.25 227.462 465.34 227.761 467.43 229.254C469.819 230.747 471.611 232.539 472.805 234.927C474.298 237.018 474.895 239.407 474.895 242.393ZM470.416 239.705C470.416 238.809 470.416 237.914 470.118 237.018C470.118 236.42 469.819 235.525 469.52 235.226C469.222 234.629 468.923 234.33 468.624 233.733C468.326 233.434 468.027 233.136 467.43 232.837C467.131 232.539 466.534 232.539 466.236 232.539C465.937 232.539 465.638 232.539 465.34 232.837C465.041 233.136 464.743 233.434 464.743 234.032C464.444 234.629 464.444 235.525 464.444 236.42C464.444 237.316 464.444 238.212 464.743 239.108C464.743 239.705 465.041 240.302 465.34 240.9C465.638 241.497 465.937 241.795 466.236 242.393C466.534 242.691 467.131 242.99 467.43 243.289C467.729 243.587 468.027 243.587 468.624 243.587C468.923 243.587 469.222 243.587 469.52 243.289C469.819 242.99 470.118 242.691 470.118 242.094C470.118 241.497 470.416 240.601 470.416 239.705ZM481.763 254.636L477.284 251.948V228.955L481.763 231.643V254.636Z",
    fill: "#CDC4C6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.996 200.588L410.982 198.796H411.281L411.579 198.497H411.878H412.177H412.475H412.774H413.072H413.371H413.67H413.968H414.267L414.566 198.796H414.864L415.163 199.095H415.461L416.059 199.692L416.656 199.99L417.253 200.588L417.552 200.886L418.149 201.483L418.447 202.379L419.045 202.976L419.343 203.574L419.642 204.47L419.941 205.365L420.239 206.261V207.157L420.538 208.053V208.949V209.845V210.74V211.636V212.532V213.428L420.239 214.025L419.941 214.622L419.642 215.22L419.343 215.817L419.045 216.115L418.447 216.414L415.461 218.206L415.76 217.907L416.357 217.608L416.656 217.011L416.954 216.414L417.253 215.817L417.552 215.22V214.324V213.428V212.532V211.636V210.74V209.546L417.253 208.65V208.053L416.954 207.157L416.656 206.261L416.357 205.365L416.059 204.768L415.461 203.872L415.163 203.275L414.566 202.678L413.968 202.379L413.67 201.782L413.072 201.185L412.475 200.886H412.177L411.579 200.588H411.281L410.982 200.289H410.684H410.385H410.086H409.788H409.489H409.191H408.892H408.593L408.295 200.588H407.996Z",
    fill: "url(#paint23_linear_1509_12467)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.996 214.622L410.982 212.831V219.699L407.996 221.49V214.622Z",
    fill: "#A0969B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.523 196.108L406.51 194.615L410.989 197.004L408.003 198.796L403.523 196.108Z",
    fill: "#F4EEEE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.996 198.796L410.982 197.004V198.796L407.996 200.587V198.796Z",
    fill: "#A0969B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.996 203.275L410.982 201.483V209.844L407.996 211.636V203.275Z",
    fill: "#A0969B"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.996 211.636L410.982 209.845V210.143H411.281V210.442H411.579L411.878 210.741L412.177 211.039H412.475L412.774 211.338L413.371 211.636H413.67L413.968 211.935H414.267H414.566L414.864 211.636H415.163L412.177 213.428H411.878L411.579 213.727H411.281L410.982 213.428H410.684H410.086L409.788 213.129L409.489 212.831H409.191V212.532H408.892L408.593 212.234L408.295 211.935L407.996 211.636Z",
    fill: "#F4EEEE"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.996 211.636L410.982 209.845V210.143H411.281V210.442H411.579L411.878 210.741L412.177 211.039L407.996 211.636Z",
    fill: "#A0969B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.145 208.352L424.131 206.56L424.728 206.261L425.026 205.963H425.922H426.519L427.117 206.261L428.013 206.56L428.908 206.858L429.804 207.456L430.401 207.754L431.297 208.352L431.894 208.949L432.79 209.546L433.388 210.143L433.686 210.74L434.283 211.636L434.582 212.233L435.179 213.129L435.478 214.025L435.776 214.622L436.075 215.518V216.414L436.374 217.31V218.206V219.102V221.192L433.388 222.685V220.893V219.997V219.102L433.089 218.206V217.31L432.79 216.414L432.492 215.518L432.193 214.921L431.596 214.025L431.297 213.428L430.7 212.532L430.103 211.935L429.506 211.338L428.908 210.74L428.311 210.143L427.415 209.546L426.818 209.247L425.922 208.65L425.026 208.352L424.131 208.053L423.533 207.754H422.638H422.04L421.443 208.053L421.145 208.352Z",
    fill: "url(#paint24_linear_1509_12467)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.523 217.011L426.51 215.219V215.518V215.816V216.115V216.414L426.808 216.712V217.011V217.309V217.608L427.107 217.907V218.205L427.405 218.504V218.802H427.704V219.101L428.003 219.4L428.301 219.698V219.997H428.6V220.295H428.898L429.197 220.594V220.893H429.496V221.191H429.794L430.093 221.49H430.391V221.789H430.69L430.989 222.087H431.287L431.586 222.386H431.885H432.183V222.684H432.482H432.78H433.079L433.378 222.983H433.676H433.975H434.273H434.572H434.871H435.169V222.684H435.468H435.766L432.482 224.476H432.183H431.885V224.775H431.586H431.287H430.989H430.69H430.391V224.476H430.093H429.794H429.496H429.197V224.177H428.898H428.6V223.879H428.301H428.003V223.58H427.704L427.405 223.282H427.107L426.808 222.983H426.51V222.684L426.211 222.386H425.912V222.087H425.614V221.789H425.315L425.016 221.49V221.191H424.718V220.893V220.594H424.419V220.295L424.121 219.997V219.698V219.4H423.822V219.101V218.802V218.504L423.523 218.205V217.907V217.608V217.309V217.011Z",
    fill: "url(#paint25_linear_1509_12467)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.484 224.476L435.769 222.684L436.068 222.983L433.082 224.775L432.484 224.476Z",
    fill: "#F4EEEE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.09 224.775L436.076 222.983V227.164L433.09 228.956V224.775Z",
    fill: "#A0969B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.419 211.935L427.405 210.143L427.107 210.441L426.808 210.74V211.039L426.51 211.337V211.636V211.935V212.233L423.523 214.025V213.726V213.129V212.83H423.822V212.532V212.233H424.121L424.419 211.935Z",
    fill: "#A0969B"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.523 214.025L426.51 212.233L431.885 215.518L428.898 217.011L423.523 214.025Z",
    fill: "#F4EEEE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.523 214.025L426.51 212.233L429.794 214.323C427.107 213.726 426.51 213.427 423.523 214.025Z",
    fill: "url(#paint26_linear_1509_12467)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.281 214.025L437.267 212.233L439.059 213.129L436.073 214.92L434.281 214.025Z",
    fill: "#F4EEEE"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.074 210.143L439.06 208.352L443.539 211.039L440.553 212.831L436.074 210.143Z",
    fill: "#F4EEEE"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.555 212.83L443.541 211.039V215.816L440.555 217.608V212.83Z",
    fill: "#A0969B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.555 217.609L443.541 215.817L447.721 218.206L444.735 219.997L440.555 217.609Z",
    fill: "#F4EEEE"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.555 217.609L443.541 215.817L446.527 217.609H440.555Z",
    fill: "#A0969B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.73 219.997L447.717 218.205V222.087L444.73 223.58V219.997Z",
    fill: "#A0969B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.555 221.192L443.541 219.4V225.372V225.671V225.97V226.268V226.567V226.865V227.164V227.463V227.761V228.06H443.839V228.358V228.657L444.138 228.956V229.254H444.437V229.553H444.735V229.851H445.034V230.15H445.332V230.449H445.631H445.93V230.747H446.228H446.527H446.825L447.124 231.046H447.423L444.437 232.838H444.138V232.539H443.839H443.541H443.242H442.944V232.24H442.645L442.346 231.942H442.048L441.749 231.643L441.45 231.345V231.046H441.152V230.747L440.853 230.449V230.15L440.555 229.851V229.553V229.254V228.956V228.657V228.358V228.06V227.761V227.463V227.164V221.192Z",
    fill: "#F4EEEE"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.55 221.192L443.536 219.4V225.372V225.671V225.97V226.268V226.567V226.865V227.164V227.463V227.761V228.06V228.358V228.657V228.956V229.254V229.553V229.851V230.15V230.449V230.747V231.046V231.345C442.043 231.643 439.953 231.643 439.355 231.046V230.747V230.449V230.15V229.851V229.553V229.254V228.956V228.657V228.358V228.06V227.761V227.463V227.164V226.865V221.192H440.55Z",
    fill: "#A0969B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.426 232.837L447.412 231.046H447.711L444.724 232.837H444.426Z",
    fill: "#F4EEEE"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.73 232.837L447.717 231.046V234.928L444.73 236.719V232.837Z",
    fill: "#A0969B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.004 229.254L453.99 227.462V238.511L451.004 240.303V229.254Z",
    fill: "#A0969B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.527 221.192L449.513 219.4L453.993 222.088L451.007 223.581L446.527 221.192Z",
    fill: "#F4EEEE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.004 223.58L453.99 222.087V224.476L451.004 225.969V223.58Z",
    fill: "#A0969B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.004 225.969L453.99 224.476L454.289 224.178H454.587H454.886L455.184 223.879H455.483H455.782H456.08H456.379H456.677H456.976H457.275H457.573L457.872 224.178H458.171L458.469 224.476H458.768V224.775H459.066L459.365 225.074L456.379 226.865V226.567H456.08H455.782V226.268H455.483L455.184 225.969H454.886L454.587 225.671H454.289H453.99H453.691H453.393H453.094H452.796H452.497H452.198H451.9V225.969H451.601H451.302H451.004Z",
    fill: "#F4EEEE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.371 226.865L459.357 225.073V229.851L456.371 231.643V226.865Z",
    fill: "#A0969B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.766 230.15L462.05 228.359L462.349 228.06H462.946L463.543 227.761L464.141 228.06H465.036L465.634 228.359L466.53 228.657L467.425 229.254L468.321 229.553L469.217 230.15L469.814 230.747L470.71 231.643L471.307 232.24L471.905 233.136L472.502 233.734L472.8 234.629L473.398 235.525L473.696 236.421L473.995 237.317L474.293 238.213L474.592 239.407L474.891 240.303V241.199V242.393V243.289V244.185L474.592 245.081L474.293 245.678L473.995 246.275L473.696 246.872L473.398 247.171L472.8 247.768L469.814 249.261L470.411 248.963L470.71 248.664L471.009 248.067L471.307 247.47L471.606 246.574V245.977L471.905 245.081V244.185V242.99L471.606 242.095V240.9L471.307 240.004L471.009 239.109L470.71 238.213L470.411 237.317L469.814 236.421L469.516 235.525L468.918 234.629L468.321 234.032L467.425 233.435L466.828 232.539L465.932 231.942L465.335 231.345L464.439 230.747L463.543 230.449L462.648 230.15L462.05 229.852L461.155 229.553H460.557H459.96L459.363 229.852L458.766 230.15Z",
    fill: "url(#paint27_linear_1509_12467)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.655 234.33L465.641 232.539L465.343 232.837L465.044 233.136V233.435L464.746 233.733V234.032V234.33V234.629V234.928V235.226V235.525L464.447 236.122V236.421V236.719L464.746 237.018V237.316V237.914V238.212V238.511V238.81V239.108L465.044 239.407V239.705V240.004V240.303H465.343V240.601V240.9L465.641 241.198V241.497L465.94 241.796L466.239 242.094L466.537 242.393L466.836 242.691H467.135V242.99H467.433L467.732 243.289H468.03H468.329V243.587H468.628H468.926L469.225 243.289L466.239 245.08H465.94V245.379H465.641V245.08H465.343H465.044H464.746L464.447 244.782H464.148L463.85 244.483L463.551 244.185L463.253 243.886L462.954 243.587V243.289H462.655V242.99L462.357 242.691V242.393L462.058 242.094V241.796V241.497L461.76 241.198V240.9V240.601V240.303V240.004V239.705V239.407L461.461 239.108V238.81V238.511V238.212V237.615V237.316V237.018L461.76 236.719V236.421V236.122V235.823V235.525L462.058 235.226V234.928L462.357 234.629L462.655 234.33Z",
    fill: "#F4EEEE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.65 234.33L465.636 232.539V232.837V233.136V233.435V233.733V234.032V234.33V234.629V234.928V235.226V235.525V235.823V236.122V236.421V236.719V237.018V237.316V237.615V237.914V238.212V238.511V238.81V239.108V239.407V239.705V240.004V240.303V240.601V240.9V241.198V241.497V241.796V242.094V242.393C464.74 242.691 462.65 242.691 461.754 242.393V242.094V241.796V241.497V241.198V240.9V240.601V240.303V240.004V239.705V239.407V239.108V238.81V238.511V238.212V237.914V237.615V237.316V237.018V236.719V236.421V236.122V235.823V235.525V235.226L462.65 234.33Z",
    fill: "url(#paint28_linear_1509_12467)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.289 230.747L477.275 228.956L481.754 231.344L478.768 233.136L474.289 230.747Z",
    fill: "#F4EEEE"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.766 233.136L481.752 231.344V254.636L478.766 256.428V233.136Z",
    fill: "#A0969B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.564 212.532C417.564 215.219 416.967 217.011 415.772 217.907C414.578 218.803 413.085 218.803 411.293 217.907C410.696 217.608 409.8 217.011 409.501 216.414C408.904 215.817 408.307 215.219 407.71 214.622V221.49L403.23 218.803V196.108L407.71 198.796V200.587C408.307 200.289 408.904 200.289 409.8 200.289C410.397 200.289 411.293 200.587 412.189 201.185C413.98 202.08 415.175 203.574 416.071 205.664C417.265 207.455 417.564 209.844 417.564 212.532ZM413.085 209.844C413.085 208.351 412.786 206.858 412.487 205.962C412.189 205.067 411.293 204.171 410.397 203.574C410.098 203.275 409.501 203.275 409.203 202.976C408.904 202.976 408.307 202.976 408.008 202.976V211.337C408.307 211.636 408.605 211.935 408.904 211.935C409.203 212.233 409.501 212.233 409.8 212.532C410.994 213.129 411.592 213.129 412.189 212.83C412.786 212.83 413.085 211.636 413.085 209.844ZM427.418 227.164C424.73 225.671 422.64 223.581 421.147 221.192C419.654 218.803 419.057 216.414 419.057 213.428C419.057 210.74 419.654 208.949 421.147 208.053C422.64 207.157 424.432 207.456 426.821 208.949C428.911 210.143 430.703 211.935 431.897 214.025C433.092 216.115 433.689 218.206 433.689 220.893V222.685L423.835 217.011C423.835 217.907 424.133 218.504 424.133 219.101C424.432 219.699 424.73 220.296 425.029 220.893C425.328 221.49 425.925 221.789 426.522 222.386C427.119 222.685 427.717 223.282 428.314 223.58C428.911 223.879 429.21 224.178 429.807 224.178C430.404 224.476 430.703 224.476 431.3 224.476C431.598 224.476 431.897 224.476 432.196 224.476C432.494 224.476 432.793 224.476 433.092 224.476L433.689 224.775V228.956C433.39 228.956 433.092 228.956 432.793 228.956C432.494 228.956 432.196 228.956 431.598 228.657C431.001 228.657 430.703 228.358 430.105 228.06C428.911 228.06 428.314 227.462 427.418 227.164ZM428.911 217.011C428.911 215.817 428.612 214.921 428.314 214.025C428.015 213.129 427.119 212.532 426.522 211.935C425.626 211.337 425.029 211.337 424.432 211.636C423.835 211.935 423.536 212.532 423.536 213.726L428.911 217.011ZM441.154 234.928C439.362 233.733 437.869 232.539 437.272 231.344C436.376 229.851 436.078 228.358 436.078 226.268V218.504L434.286 217.608V214.025L436.078 214.921V210.143L440.557 212.83V217.608L445.036 219.997V223.58L440.557 221.192V227.164C440.557 227.761 440.557 228.358 440.557 228.657C440.557 228.956 440.557 229.553 440.855 229.851C440.855 230.15 441.154 230.747 441.453 231.046C441.751 231.344 442.348 231.643 442.647 232.24C442.946 232.24 443.244 232.539 443.543 232.539C443.842 232.539 444.14 232.837 444.439 232.539L444.737 232.837V236.421C444.14 236.421 443.842 236.122 443.244 235.824C442.647 235.824 442.05 235.525 441.154 234.928ZM456.383 231.643L456.085 231.344C455.786 231.046 455.786 231.046 455.189 230.747C454.89 230.449 454.592 230.15 453.994 230.15C453.397 229.851 453.098 229.553 452.501 229.553C451.904 229.553 451.605 229.254 451.008 229.254V240.303L446.529 237.615V220.893L451.008 223.58V225.969C451.307 225.969 451.605 225.671 451.904 225.671C452.203 225.671 452.501 225.372 452.8 225.372C453.098 225.372 453.397 225.372 453.994 225.372C454.293 225.372 454.89 225.671 455.189 225.969C455.189 225.969 455.487 226.268 455.786 226.268C456.085 226.268 456.085 226.567 456.383 226.567V231.643ZM471.911 244.185C471.911 246.872 471.314 248.664 469.821 249.56C468.626 250.456 466.536 250.157 464.446 248.664C462.057 247.171 460.265 245.379 459.071 242.99C457.876 240.601 456.98 238.212 456.98 235.525C456.98 232.837 457.578 231.046 459.071 230.15C460.265 229.254 462.355 229.553 464.446 231.046C466.835 232.539 468.626 234.331 469.821 236.719C471.015 239.108 471.911 241.199 471.911 244.185ZM467.133 241.497C467.133 240.601 467.133 239.706 466.835 238.81C466.835 238.212 466.536 237.317 466.237 237.018C465.939 236.421 465.64 236.122 465.341 235.525C465.043 235.226 464.744 234.928 464.147 234.629C463.848 234.331 463.251 234.331 462.953 234.331C462.654 234.331 462.355 234.331 462.057 234.629C461.758 234.928 461.46 235.226 461.46 235.824C461.161 236.421 461.161 237.317 461.161 238.212C461.161 239.108 461.161 240.004 461.46 240.9C461.46 241.497 461.758 242.094 462.057 242.692C462.355 243.289 462.654 243.587 462.953 244.185C463.251 244.483 463.848 244.782 464.147 245.081C464.446 245.379 464.744 245.379 465.341 245.379C465.64 245.379 465.939 245.379 466.237 245.081C466.536 244.782 466.835 244.483 466.835 243.886C467.133 243.289 467.133 242.393 467.133 241.497ZM478.779 256.428L474.3 253.74V230.747L478.779 233.435V256.428Z",
    fill: "#CDC4C6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.522 385.308L193.953 383.802L240.075 357.168H247.781L250.38 358.674L204.229 385.308H196.522ZM240.588 406.511C240.318 406.318 240.008 406.12 239.659 405.918C236.234 403.939 230.21 402.315 226.283 402.345C222.297 402.345 221.883 403.939 225.309 405.918C227.966 407.453 232.188 408.774 235.795 409.29L234.786 409.874L236.469 410.849H241.784C246.42 410.849 253.152 412.709 257.138 415.071L256.267 415.576C255.998 415.383 255.688 415.185 255.339 414.983C251.913 412.975 245.919 411.38 241.963 411.41C237.976 411.41 237.563 413.004 240.988 414.983C243.646 416.518 247.867 417.839 251.474 418.354L250.465 418.939L250.467 418.941L250.467 418.941C251.027 419.265 251.588 419.589 252.177 419.914H262.866L266.292 417.929L271.059 420.681H258.289L255.809 422.099C259.337 424.136 262.873 426.173 266.409 428.211L266.42 428.217C269.952 430.252 273.484 432.288 277.009 434.323C280.534 436.358 284.066 438.394 287.599 440.429L287.609 440.435C291.145 442.473 294.681 444.51 298.21 446.547H311.408L313.641 445.271L320.189 449.052L311.422 454.107L318.095 457.975H318.907C317.956 458.603 318.559 459.728 320.789 461.016C324.214 462.995 330.238 464.619 334.194 464.619C338.151 464.619 338.565 462.995 335.139 461.016C331.759 459.08 326.004 457.512 322.023 457.446L328.375 453.78L363.914 474.302H384.867L372.161 481.744H371.511L371.836 481.922L371.305 482.217L372.899 482.512C376.531 484.631 380.179 486.733 383.819 488.832C385.151 489.6 386.482 490.367 387.81 491.134C388.082 491.248 388.206 491.284 388.305 491.313C388.541 491.381 388.643 491.411 390.261 492.345C390.47 492.467 390.669 492.6 390.854 492.743L389.825 493.338C389.614 492.759 388.867 492.06 387.569 491.311C384.233 489.384 378.461 487.821 374.507 487.741L374.817 487.561L336.343 465.357H333.331L332.061 466.065L370.535 488.299H371.292C370.406 488.933 371.024 490.043 373.219 491.311C376.644 493.289 382.668 494.913 386.624 494.913C386.795 494.913 386.96 494.91 387.118 494.904C385.563 495.804 384.642 496.339 384.561 496.39L384.561 496.39H384.533L384.571 496.412L384.571 496.412L384.571 496.412L384.572 496.412L384.572 496.412L384.572 496.413C385.947 497.202 387.322 497.992 388.726 498.811C389.921 499.505 391.117 500.191 392.313 500.878C393.509 501.564 394.705 502.251 395.901 502.945H401.57L401.57 502.945H401.598L403.438 501.882H412.938L413.765 501.409L414.592 501.882H430.625H435.69C435.576 501.948 435.462 502.014 435.348 502.081C435.278 502.123 435.207 502.165 435.137 502.207H433.779C432.568 502.915 431.328 503.624 430.117 504.303L431.8 505.278H447.981L451.642 503.181L449.959 502.207L450.58 501.882L455.841 501.882C467.08 494.801 479.008 488.064 490.804 481.402L490.805 481.401L490.808 481.4L490.81 481.399L490.826 481.39L490.828 481.388L490.83 481.387C495.946 478.498 501.038 475.622 506.037 472.739L505.193 472.251C505.424 472.117 505.654 471.984 505.884 471.852L504.201 470.878H502.815L486.608 461.518L485.575 455.111H459.789L472.722 447.639L317.792 358.201H255.135L208.984 384.835L212.565 386.902H212.434H211.755L203.398 391.745C203.752 391.961 204.132 392.177 204.512 392.393L204.512 392.393C204.703 392.502 204.894 392.611 205.082 392.719H210.396C215.032 392.719 221.764 394.579 225.751 396.942L224.847 397.465C224.521 397.211 224.124 396.947 223.655 396.676C220.23 394.697 214.236 393.103 210.279 393.103C206.293 393.103 205.879 394.697 209.305 396.676C212.083 398.28 216.572 399.652 220.279 400.113L219.077 400.81C219.373 400.972 219.653 401.134 219.934 401.297C220.214 401.459 220.495 401.622 220.79 401.784H226.105C230.741 401.784 237.473 403.644 241.459 406.006L240.588 406.511ZM440.452 502.207L441.013 501.882L441.013 501.882H445.316C445.13 501.989 444.946 502.097 444.763 502.207H440.452Z",
    fill: "#39444F"
  }))), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.217 420.947L359.89 424.785L313.739 451.419L307.066 447.58L353.217 420.947Z",
    fill: "#F7F2EC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.496 427.827L337.453 442.885L378.23 466.419L404.303 451.389L363.496 427.827Z",
    fill: "#63645C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.483 419.263L347.633 423.22V425.612L354.483 421.685V419.263Z",
    fill: "url(#paint29_linear_1509_12467)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.363 422.482L347.633 423.22V425.612L346.363 424.874V422.482Z",
    fill: "#CE2F17"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.213 418.555L346.363 422.482L347.633 423.22L354.483 419.263L353.213 418.555Z",
    fill: "#E03118"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.827 445.986L366.215 471.143V484.725L409.827 459.568V445.986Z",
    fill: "url(#paint30_linear_1509_12467)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.184 416.134L349.828 420.977L363.115 423.782L370.202 417.788L363.558 413.979L358.184 416.134Z",
    fill: "#63645C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.828 420.976L355.202 418.791L361.846 422.63L367.22 431.016V430.956L349.828 420.947V420.976Z",
    fill: "#545950"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.199 417.788L361.843 422.63L355.199 418.792L363.555 413.979L370.199 417.788Z",
    fill: "#63645C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.2 417.788L361.844 422.63L367.129 431.016L375.485 426.173L370.2 417.788Z",
    fill: "#444C48"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.917 443.624L307.066 447.581L308.336 448.319H310.728L317.578 444.362L316.308 443.624H313.917Z",
    fill: "url(#paint31_linear_1509_12467)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.933 437.747L313.742 444.184V454.43L324.933 447.994V437.747Z",
    fill: "#090E06"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.134 461.458C324.012 462.108 322.447 462.019 320.734 461.015C319.022 460.011 317.457 458.328 316.335 456.379C315.213 454.431 314.504 452.246 314.504 450.238C314.504 448.26 315.213 446.872 316.335 446.222C317.988 445.277 319.081 444.628 320.764 443.683C321.886 443.033 323.451 443.122 325.163 444.126C326.876 445.13 328.441 446.813 329.563 448.762C330.685 450.71 331.394 452.925 331.394 454.903C331.394 456.881 330.685 458.269 329.563 458.919C327.88 459.864 326.787 460.513 325.134 461.458Z",
    fill: "#090E06"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.734 446.666C324.159 448.644 326.964 453.486 326.964 457.443C326.964 461.4 324.189 463.024 320.734 461.045C317.309 459.067 314.504 454.224 314.504 450.268C314.504 446.282 317.309 444.658 320.734 446.666Z",
    fill: "#1F2C2B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.743 450.149C322.486 451.153 323.932 453.634 323.932 455.671C323.932 457.708 322.515 458.506 320.743 457.502C319.001 456.498 317.555 454.017 317.555 452.01C317.555 449.972 318.972 449.145 320.743 450.149Z",
    fill: "#E3D6C9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.734 450.977C322.092 451.774 323.214 453.693 323.214 455.258C323.214 456.823 322.122 457.472 320.734 456.675C319.376 455.878 318.254 453.988 318.254 452.394C318.254 450.799 319.376 450.209 320.734 450.977Z",
    fill: "url(#paint32_linear_1509_12467)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.744 451.832C321.689 452.393 322.456 453.722 322.456 454.815C322.456 455.907 321.689 456.35 320.744 455.818C319.799 455.257 319.031 453.929 319.031 452.836C319.031 451.744 319.799 451.301 320.744 451.832Z",
    fill: "#E3D6C9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.761 448.791L368.64 475.424L329.457 452.807L375.579 426.173L414.761 448.791Z",
    fill: "#F7F2EC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.906 450.799L348.88 460.041H373.565L403.89 442.531L375.573 426.173L332.906 450.799Z",
    fill: "url(#paint33_linear_1509_12467)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.72 448.821L369.425 474.982L356.492 467.512L401.787 441.35L414.72 448.821Z",
    fill: "url(#paint34_linear_1509_12467)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.391 434.943L359.691 457.649V460.661L320.391 437.954V434.943Z",
    fill: "#1E2822"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.066 447.58L313.739 451.448V454.431L307.066 450.592V447.58Z",
    fill: "#E3D6C9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.606 491.753C376.484 492.403 374.919 492.314 373.207 491.31C371.494 490.306 369.929 488.623 368.807 486.674C367.685 484.726 366.977 482.54 366.977 480.533C366.977 478.554 367.685 477.167 368.807 476.517C370.461 475.572 371.553 474.922 373.236 473.978C374.358 473.328 375.923 473.417 377.636 474.421C379.348 475.425 380.913 477.107 382.035 479.056C383.157 481.005 383.866 483.22 383.866 485.198C383.866 487.176 383.157 488.564 382.035 489.214C380.352 490.158 379.26 490.779 377.606 491.753Z",
    fill: "#090E06"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.207 476.931C376.632 478.909 379.437 483.751 379.437 487.708C379.437 491.665 376.661 493.289 373.207 491.31C369.782 489.332 366.977 484.489 366.977 480.533C366.977 476.576 369.782 474.952 373.207 476.931Z",
    fill: "#1F2C2B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.209 480.444C374.951 481.448 376.398 483.929 376.398 485.966C376.398 488.003 374.98 488.801 373.209 487.797C371.466 486.793 370.02 484.312 370.02 482.305C370.02 480.267 371.437 479.44 373.209 480.444Z",
    fill: "#E3D6C9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.203 481.271C374.561 482.068 375.683 483.958 375.683 485.553C375.683 487.118 374.591 487.767 373.203 486.97C371.845 486.173 370.723 484.253 370.723 482.689C370.723 481.124 371.845 480.503 373.203 481.271Z",
    fill: "url(#paint35_linear_1509_12467)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.213 482.127C374.158 482.688 374.926 484.017 374.926 485.11C374.926 486.202 374.158 486.645 373.213 486.113C372.269 485.552 371.501 484.224 371.501 483.131C371.471 482.039 372.269 481.596 373.213 482.127Z",
    fill: "#E3D6C9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.186 441.97L308.336 445.927V448.319L315.186 444.362V441.97Z",
    fill: "url(#paint36_linear_1509_12467)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.066 445.188L308.336 445.927V448.318L307.066 447.58V445.188Z",
    fill: "#CE2F17"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.917 441.232L307.066 445.189L308.336 445.927L315.186 441.97L313.917 441.232Z",
    fill: "#E03118"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.804 417.964L320.395 434.943L378.238 468.367L407.648 451.389L349.804 417.964Z",
    fill: "#1E2822"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.461 436.715L328.097 438.073L334.74 441.911L334.799 443.27L323.461 436.715Z",
    fill: "#1E2822"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.289 435.327L350.446 429.451C353.133 431.016 358.33 433.053 362.287 435.327L358.478 437.541H356.795L354.226 436.065L355.466 435.327L351.303 432.906L347.139 435.327L351.303 437.748L351.716 437.512H353.399L355.968 438.988L352.159 441.203H350.476L340.289 435.327Z",
    fill: "#1E2822"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.465 433.673V435.326L350.445 432.433V430.779L355.465 433.673Z",
    fill: "#1E2822"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.302 432.935L350.445 432.433V430.779L351.302 432.935Z",
    fill: "#1E2822"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.446 439.519V441.203L340.289 435.326V433.673L350.446 439.519Z",
    fill: "#1E2822"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.788 435.887V437.541L354.219 436.064V434.382L356.788 435.887Z",
    fill: "#1E2822"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.793 435.858V437.541L360.602 435.326V433.673L356.793 435.858Z",
    fill: "#1E2822"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.445 439.519V441.202L354.284 438.988V437.334L350.445 439.519Z",
    fill: "#1E2822"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.457 433.673V435.326L350.447 432.433V430.779L345.457 433.673Z",
    fill: "#1E2822"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.289 433.673L350.446 427.797L360.604 433.673L356.795 435.888L354.226 434.411L355.466 433.673L350.446 430.779C348.763 431.754 347.11 432.699 345.427 433.673L350.446 436.567L351.687 435.858L354.255 437.335L350.446 439.549L340.289 433.673Z",
    fill: "#1E2822"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.419 437.954L312.062 442.767L325.35 445.602L332.436 439.608L325.793 435.769L320.419 437.954Z",
    fill: "#1E2822"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.64 475.424C367.222 476.074 366.248 477.698 366.248 480.09V484.725L355.736 478.643L329.457 463.466V452.777L368.64 475.424Z",
    fill: "#E3D6C9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.053 442.768L317.427 440.612L324.07 444.451L329.444 452.807V463.496L327.732 462.521V457.207C327.732 452.748 324.602 447.315 320.734 445.1C316.866 442.886 313.736 444.687 313.736 449.146V454.461L312.023 453.486L312.053 442.768Z",
    fill: "#3A4440"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.437 439.608L324.081 444.45L317.438 440.612L325.794 435.769L332.437 439.608Z",
    fill: "#1E2822"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.438 439.608L324.082 444.451L329.456 452.807L337.812 447.964L332.438 439.608Z",
    fill: "#1E2822"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.862 367.768L187.012 371.695V374.087L193.862 370.16V367.768Z",
    fill: "url(#paint37_linear_1509_12467)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.742 370.957L187.012 371.695V374.087L185.742 373.378V370.957Z",
    fill: "#CE2F17"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.593 367.03L185.742 370.957L187.012 371.695L193.862 367.768L192.593 367.03Z",
    fill: "#E03118"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.757 344.057L189.605 370.691V378.398L235.757 351.764V344.057Z",
    fill: "url(#paint38_linear_1509_12467)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.761 344.058L189.61 370.692L187.012 369.186L233.163 342.552L235.761 344.058Z",
    fill: "#F7F2EC"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.065 351.971L238.68 356.814L251.967 359.619L259.054 353.654L252.41 349.816L247.065 351.971Z",
    fill: "#4B5550"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.68 356.813L244.054 354.628L250.697 358.467L256.071 366.852V366.823L238.68 356.784V356.813Z",
    fill: "#2A3530"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.055 353.654L250.698 358.467L244.055 354.629L252.411 349.816L259.055 353.654Z",
    fill: "#63645C"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.055 353.654L250.699 358.467L255.985 366.853L264.37 362.011L259.055 353.654Z",
    fill: "#444C48"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.98 362.099L248.315 360.741L241.76 356.961L241.73 355.603L252.98 362.099Z",
    fill: "#2A3530"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.194 351.823L205.785 368.802L310.961 429.539L340.37 412.561L235.194 351.823Z",
    fill: "#63645C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.34 363.339L310.964 429.539V438.132L196.34 371.961V363.339Z",
    fill: "#1E2822"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.374 412.561L310.965 429.539V438.132L340.374 421.154V412.561Z",
    fill: "#1E2822"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.796 373.585L202.605 380.051V390.297L213.796 383.831V373.585Z",
    fill: "#090E06"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.997 397.295C212.875 397.945 211.31 397.856 209.598 396.852C207.885 395.848 206.32 394.165 205.198 392.217C204.076 390.268 203.367 388.083 203.367 386.075C203.367 384.097 204.076 382.679 205.198 382.059C206.852 381.114 207.944 380.465 209.627 379.52C210.749 378.87 212.314 378.959 214.027 379.963C215.739 380.967 217.304 382.65 218.426 384.599C219.548 386.547 220.257 388.762 220.257 390.74C220.257 392.719 219.548 394.106 218.426 394.756C216.743 395.701 215.651 396.35 213.997 397.295Z",
    fill: "#090E06"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.598 382.503C213.023 384.481 215.828 389.324 215.828 393.28C215.828 397.237 213.052 398.861 209.598 396.883C206.172 394.904 203.367 390.062 203.367 386.105C203.367 382.119 206.172 380.525 209.598 382.503Z",
    fill: "#1F2C2B"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.278 373.792L200.922 378.605L214.209 381.439L221.296 375.445L214.652 371.607L209.278 373.792Z",
    fill: "#1E2822"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.916 378.605L206.29 376.45L212.934 380.288L218.308 388.644V399.333L216.595 398.359V393.044C216.595 388.585 213.465 383.152 209.597 380.938C205.729 378.723 202.599 380.524 202.599 384.983V390.298L200.887 389.324L200.916 378.605Z",
    fill: "#3A4440"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.297 375.445L212.94 380.288L206.297 376.449L214.653 371.607L221.297 375.445Z",
    fill: "url(#paint39_linear_1509_12467)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.297 375.445L212.941 380.288L217.459 387.315L225.815 382.502L221.297 375.445Z",
    fill: "#1E2822"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.478 382.62L218.316 389.087V399.333L229.478 392.866V382.62Z",
    fill: "#090E06"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.684 406.361C228.562 407.01 226.997 406.922 225.285 405.918C223.572 404.914 222.007 403.231 220.885 401.282C219.763 399.333 219.055 397.148 219.055 395.14C219.055 393.162 219.763 391.774 220.885 391.125C222.539 390.18 223.631 389.53 225.314 388.585C226.436 387.936 228.001 388.024 229.714 389.028C231.427 390.032 232.991 391.715 234.113 393.664C235.236 395.613 235.944 397.827 235.944 399.806C235.944 401.784 235.236 403.172 234.113 403.821C232.43 404.766 231.367 405.386 229.684 406.361Z",
    fill: "#090E06"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.285 391.537C228.71 393.516 231.515 398.358 231.515 402.315C231.515 406.271 228.74 407.896 225.285 405.917C221.86 403.939 219.055 399.096 219.055 395.14C219.084 391.183 221.86 389.559 225.285 391.537Z",
    fill: "#1F2C2B"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.805 382.502L217.449 387.315L229.88 390.475L236.996 384.51L230.353 380.672L225.805 382.502Z",
    fill: "#1E2822"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.604 387.67L221.978 385.484L228.621 389.323L233.995 397.679V408.368L232.283 407.394V402.079C232.283 397.62 229.153 392.187 225.285 389.973C221.417 387.758 218.287 389.559 218.287 394.018V399.333L216.574 398.358L216.604 387.67Z",
    fill: "#3A4440"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.998 384.51L228.612 389.323L221.969 385.484L230.354 380.672L236.998 384.51Z",
    fill: "url(#paint40_linear_1509_12467)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.003 384.511L228.617 389.324L233.991 397.709L242.347 392.867L237.003 384.511Z",
    fill: "#1E2822"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.183 391.685L233.992 398.152V408.398L245.183 401.931V391.685Z",
    fill: "#090E06"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.392 415.396C244.27 416.046 242.705 415.957 240.992 414.953C239.28 413.949 237.714 412.266 236.592 410.317C235.47 408.369 234.762 406.184 234.762 404.176C234.762 402.197 235.47 400.81 236.592 400.16C238.246 399.215 239.338 398.566 241.021 397.621C242.144 396.971 243.709 397.06 245.421 398.064C247.134 399.067 248.699 400.751 249.821 402.699C250.943 404.648 251.651 406.863 251.651 408.841C251.651 410.819 250.943 412.207 249.821 412.857C248.138 413.802 247.045 414.451 245.392 415.396Z",
    fill: "#090E06"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.992 400.603C244.417 402.581 247.222 407.423 247.222 411.38C247.222 415.337 244.447 416.961 240.992 414.982C237.567 413.004 234.762 408.162 234.762 404.205C234.762 400.219 237.537 398.624 240.992 400.603Z",
    fill: "#1F2C2B"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.523 391.538L233.137 396.38L245.597 399.54L252.684 393.546L246.04 389.707L241.523 391.538Z",
    fill: "#1E2822"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.311 396.705L237.685 394.549L244.328 398.388L249.702 406.744V417.433L247.99 416.459V411.144C247.99 406.685 244.86 401.252 240.992 399.038C237.124 396.823 233.994 398.624 233.994 403.083V408.398L232.281 407.423L232.311 396.705Z",
    fill: "#3A4440"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.679 393.546L244.323 398.388L237.68 394.55L246.036 389.707L252.679 393.546Z",
    fill: "url(#paint41_linear_1509_12467)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.68 393.546L244.324 398.389L249.669 406.745L258.054 401.932L252.68 393.546Z",
    fill: "#1E2822"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.046 412.591L249.66 417.433V406.744L258.046 401.931V412.591Z",
    fill: "url(#paint42_linear_1509_12467)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.27 406.301L255.72 404.884L298.121 429.362L295.641 430.779L253.27 406.301Z",
    fill: "#F7F2EC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.492 405.032L255.728 404.884L298.129 429.362L297.864 429.51L255.492 405.032Z",
    fill: "url(#paint43_linear_1509_12467)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.941 390.416L187.012 300.978V363.635L341.941 453.073V390.416Z",
    fill: "#E3D6C9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.938 390.416L388.089 363.782V426.439L341.938 453.073V390.416Z",
    fill: "url(#paint44_linear_1509_12467)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.938 390.416L388.089 363.782V416.282L341.938 442.915V390.416Z",
    fill: "#525C74"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.163 274.344L187.012 300.978L341.941 390.416L388.092 363.782L233.163 274.344Z",
    fill: "#F7F2EC"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.012 369.186V376.893L189.61 378.399V370.692L187.012 369.186Z",
    fill: "#E3D6C9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.641 443.978L253.27 419.5V406.301L295.641 430.779V443.978Z",
    fill: "#E3D6C9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.117 429.362V442.561L295.637 443.978V430.779L298.117 429.362Z",
    fill: "url(#paint45_linear_1509_12467)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.085 426.675L436.402 425.701V409.52L438.085 410.495V426.675Z",
    fill: "url(#paint46_linear_1509_12467)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.747 408.398L440.064 407.424L436.402 409.52L438.085 410.495L441.747 408.398Z",
    fill: "url(#paint47_linear_1509_12467)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.747 408.398V424.549L438.086 426.675V410.494L441.747 408.398Z",
    fill: "url(#paint48_linear_1509_12467)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.085 413.772L436.402 412.827L434.188 414.096L435.841 415.071L438.085 413.772Z",
    fill: "#2A3530"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.836 417.02V415.071L438.08 413.772V415.721L435.836 417.02Z",
    fill: "#2A3530"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.085 423.369L436.402 422.394L434.188 423.694L435.841 424.668L438.085 423.369Z",
    fill: "#2A3530"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.836 426.588V424.668L438.08 423.369V425.318L435.836 426.588Z",
    fill: "#2A3530"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.747 408.398L440.064 407.424L439.355 407.808L441.039 408.782L441.747 408.398Z",
    fill: "#F7F2EC"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.84 452.748L389.719 479.381V498.279L435.84 471.645V452.748Z",
    fill: "url(#paint49_linear_1509_12467)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.849 452.748L389.727 479.382L354.855 459.244L400.977 432.611L435.849 452.748Z",
    fill: "#FFEA80"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.844 452.748L390.549 478.909L356.504 459.244L401.799 433.112L435.844 452.748Z",
    fill: "url(#paint50_linear_1509_12467)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.043 449.5L388.461 474.686L356.129 456.025L399.711 430.839L432.043 449.5Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.84 409.845L389.719 436.479V477.729L435.84 451.095V409.845Z",
    fill: "url(#paint51_linear_1509_12467)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.855 407.896L385.357 425.494L389.727 436.478V461.695V477.698C377.149 470.435 366.991 464.559 354.855 457.561V407.896Z",
    fill: "#ECC56B"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.722 441.705V446.99L388.039 442.679C388.039 442.03 388.039 441.38 388.039 440.731L389.722 441.705ZM389.722 451.301V456.587L388.039 452.276C388.039 451.626 388.039 450.976 388.039 450.327L389.722 451.301Z",
    fill: "url(#paint52_linear_1509_12467)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.121 428.27V449.53L383.401 456.055V465.474L388.036 468.161V458.713V437.571V437.453L372.121 428.27Z",
    fill: "url(#paint53_linear_1509_12467)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.121 449.53L383.401 456.055L385.054 455.11V449.53H372.121Z",
    fill: "#FFEA80"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.402 465.474L388.038 468.161V465.474H383.402Z",
    fill: "#FFEA80"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.75 429.215V448.585L385.059 455.11V464.53L388.041 466.272V458.713V437.571V437.453L373.75 429.215Z",
    fill: "#596E81"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.75 429.215V448.614L375.374 449.559V431.843L388.041 439.166V437.601V437.483L373.75 429.215ZM385.059 455.11V464.53L386.683 465.474V457.738L385.059 455.11Z",
    fill: "#39444F"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.186 412.739L391.371 437.453V464.47L411.213 453.014L397.69 452.01L397.719 451.39L412.188 452.453L428.221 443.181L414.668 442.207L414.727 441.557L429.195 442.62L434.186 439.756V412.739Z",
    fill: "#39444F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1509_12467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 412,
    width: 44,
    height: 53
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.206 412.739L391.367 437.467V464.471L411.221 453.007L397.69 452.003L397.719 451.382L412.196 452.446L428.238 443.199L414.677 442.194L414.737 441.574L429.213 442.637L434.206 439.772V412.739Z",
    fill: "#39444F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1509_12467)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.54 414.53H414.416L501.953 464.727H459.077L371.54 414.53ZM351.363 414.53H363.973L451.51 464.727H438.9L351.363 414.53Z",
    fill: "white"
  }))), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.478 398.89L385.357 425.524L354.855 407.896L400.977 381.262L431.478 398.89Z",
    fill: "#FFEA80"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.993 384.156L412.046 387.67L414.29 401.547L389.959 415.602L364.891 407.896L405.993 384.156Z",
    fill: "#C09B4A"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.963 415.603L354.855 407.896V397.857L389.963 415.603Z",
    fill: "#ECC56B"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.294 401.548L389.963 415.603L354.855 397.857L400.977 371.223L414.294 401.548Z",
    fill: "#FFEA80"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.85 459.244L389.722 479.382V492.61L391.582 493.673V499.342L384.407 495.208L380.214 492.787V488.151C380.214 483.693 377.084 478.26 373.216 476.045C372.478 475.632 371.799 475.336 371.119 475.218L354.82 465.799V459.244H354.85Z",
    fill: "#ECC56B"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.916 448.761V451.301L392.641 474.568V472.029L432.916 448.761ZM432.916 445.425L392.641 468.692V471.232L432.916 447.964V445.425ZM400.908 474.775V477.314L424.648 463.614V461.074L400.908 474.775ZM400.908 478.141V480.68L424.648 466.98V464.44L400.908 478.141ZM400.908 481.477V484.017L424.648 470.316V467.777L400.908 481.477Z",
    fill: "#7B5A20"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.355 449.087V450.976L392.641 473.919V472.029L432.355 449.087ZM392.641 470.553L432.355 447.61V445.72L392.641 468.663V470.553ZM400.908 474.775V476.665L424.087 463.289V461.399L400.908 474.775ZM400.908 478.141V480.031L424.087 466.655V464.766L400.908 478.141ZM400.908 481.478V483.368L424.087 469.992V468.102L400.908 481.478Z",
    fill: "url(#paint54_linear_1509_12467)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.305 420.859L368.133 425.967V447.226L359.305 442.148V420.859Z",
    fill: "url(#paint55_linear_1509_12467)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.128 445.336L360.953 441.203V421.803L368.128 425.966V445.336Z",
    fill: "#ECC56B"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.577 442.147L360.953 441.203V421.803L368.128 425.966V427.649L362.577 424.431V442.147Z",
    fill: "url(#paint56_linear_1509_12467)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.133 445.337L362.582 442.148H359.305L368.133 447.226V445.337Z",
    fill: "#FFEA80"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.125 454.461L376.052 456.734L376.79 458.594V459.598L373.572 457.738V458.742L372.834 458.299L372.479 457.384L372.125 456.439V455.022V454.461Z",
    fill: "#9B7232"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.863 455.878L372.125 456.321V457.295L372.863 456.882V455.878Z",
    fill: "url(#paint57_linear_1509_12467)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.387 454.874L375.314 457.177V458.151L372.125 456.291V457.295L371.387 456.882V455.464V454.874Z",
    fill: "#E3D6C9"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.047 456.734L375.309 457.177V458.152L376.047 457.738V456.734Z",
    fill: "url(#paint58_linear_1509_12467)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.125 454.461L376.052 456.734L375.314 457.177L371.387 454.874L372.125 454.461Z",
    fill: "#F7F2EC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.719 492.64L391.579 493.703L437.7 467.069L435.84 466.006L389.719 492.64Z",
    fill: "#FFEA80"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.439 492.64L437.7 467.069L435.84 466.006L389.719 492.64H393.439Z",
    fill: "url(#paint59_linear_1509_12467)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.704 467.069L391.582 493.702V499.371L437.704 472.738V467.069Z",
    fill: "url(#paint60_linear_1509_12467)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.21 477.167L393.359 481.094V487.384L400.21 483.427V477.167Z",
    fill: "url(#paint61_linear_1509_12467)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.09 480.356L393.359 481.094V487.383L392.09 486.645V480.356Z",
    fill: "url(#paint62_linear_1509_12467)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.94 476.429L392.09 480.356L393.359 481.094L400.21 477.167L398.94 476.429Z",
    fill: "url(#paint63_linear_1509_12467)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.753 457.207L427.902 461.164V467.423L434.753 463.496V457.207Z",
    fill: "url(#paint64_linear_1509_12467)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.633 460.425L427.902 461.163V467.423L426.633 466.685V460.425Z",
    fill: "url(#paint65_linear_1509_12467)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.483 456.469L426.633 460.425L427.902 461.163L434.753 457.207L433.483 456.469Z",
    fill: "url(#paint66_linear_1509_12467)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.407 490.011L394.586 493.968V497.098L401.407 493.141V490.011Z",
    fill: "url(#paint67_linear_1509_12467)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.938 493.584L394.587 493.968V497.098L393.938 496.744V493.584Z",
    fill: "url(#paint68_linear_1509_12467)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.788 489.657L393.938 493.584L394.587 493.968L401.408 490.011L400.788 489.657Z",
    fill: "url(#paint69_linear_1509_12467)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.961 470.08L429.141 474.008V477.167L435.961 473.21V470.08Z",
    fill: "url(#paint70_linear_1509_12467)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.492 473.654L429.142 474.008V477.168L428.492 476.784V473.654Z",
    fill: "url(#paint71_linear_1509_12467)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.343 469.697L428.492 473.654L429.142 474.008L435.962 470.081L435.343 469.697Z",
    fill: "url(#paint72_linear_1509_12467)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.612 422.925L383.25 421.567L385.612 420.208H388.978L391.34 421.567L388.978 422.925H385.612Z",
    fill: "#B7914D"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.974 418.23L385.612 419.589L383.25 418.23L385.612 416.843L387.974 418.23Z",
    fill: "#F7AD7B"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.25 421.567L385.612 422.925V419.589L383.25 418.23V421.567Z",
    fill: "#C98753"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.975 421.567L385.613 422.925V419.589L387.975 418.23V421.567Z",
    fill: "#A05927"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.067 408.25L408.676 406.892L411.067 405.504H414.404L416.766 406.892L414.404 408.25H411.067Z",
    fill: "#B7914D"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.43 403.526L411.067 404.914L408.676 403.526L411.067 402.168L413.43 403.526Z",
    fill: "#F7AD7B"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.676 406.892L411.067 408.25V404.914L408.676 403.526V406.892Z",
    fill: "#C98753"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.425 406.892L411.062 408.25V404.914L413.425 403.526V406.892Z",
    fill: "#A05927"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.124 411.676L402.762 410.318L405.124 408.93H408.46L410.852 410.318L408.46 411.676H405.124Z",
    fill: "#B7914D"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.486 406.952L405.124 408.339L402.762 406.952L405.124 405.593L407.486 406.952Z",
    fill: "#F7AD7B"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.762 410.318L405.124 411.676V408.339L402.762 406.952V410.318Z",
    fill: "#C98753"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.487 410.318L405.125 411.676V408.339L407.487 406.952V410.318Z",
    fill: "#A05927"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.202 415.101L396.84 413.713L399.202 412.355H402.568L404.93 413.713L402.568 415.101H399.202Z",
    fill: "#B7914D"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.564 410.376L399.202 411.735L396.84 410.376L399.202 409.018L401.564 410.376Z",
    fill: "#F7AD7B"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.84 413.713L399.202 415.1V411.734L396.84 410.376V413.713Z",
    fill: "#C98753"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.565 413.713L399.203 415.1V411.734L401.565 410.376V413.713Z",
    fill: "#A05927"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.642 400.396L422.25 399.038L424.642 397.679H427.978L430.341 399.038L427.978 400.396H424.642Z",
    fill: "#B7914D"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.004 395.701L424.642 397.06L422.25 395.701L424.642 394.314L427.004 395.701Z",
    fill: "#F7AD7B"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.25 399.038L424.642 400.396V397.06L422.25 395.701V399.038Z",
    fill: "#C98753"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.999 399.038L424.637 400.396V397.06L426.999 395.701V399.038Z",
    fill: "#A05927"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.843 409.845L389.722 436.479L385.352 425.524L431.473 398.891L435.843 409.845Z",
    fill: "#B7914D"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.039 478.761L387.059 481.655V493.732L382.039 490.838V478.761Z",
    fill: "url(#paint73_linear_1509_12467)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.058 492.786L382.836 490.365V479.233L387.058 481.655V492.786Z",
    fill: "#ECC56B"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.663 490.838L382.836 490.365V479.233L387.058 481.655V482.511L383.663 480.533V490.838Z",
    fill: "url(#paint74_linear_1509_12467)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.059 492.787L383.663 490.838H382.039L387.059 493.732V492.787Z",
    fill: "#FFEA80"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.821 458.004L382.168 457.03V440.849L383.821 441.823V458.004Z",
    fill: "#E3D6C9"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.483 439.697L385.8 438.752L382.168 440.849L383.821 441.823L387.483 439.697Z",
    fill: "#F7F2EC"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.712 441.705L388.029 440.76L385.785 442.03L387.468 443.004L389.712 441.705Z",
    fill: "#63645C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.469 444.923V443.004L389.713 441.705V443.654L387.469 444.923Z",
    fill: "#2A3530"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.716 441.705L388.033 440.76L385.789 442.03L387.472 443.004L389.716 441.705Z",
    fill: "#63645C"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.789 442.03L387.472 443.004L389.155 442.03H385.789Z",
    fill: "#2A3530"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.712 451.301L388.029 450.327L385.785 451.626L387.468 452.6L389.712 451.301Z",
    fill: "#63645C"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.469 454.52V452.601L389.713 451.301V453.221L387.469 454.52Z",
    fill: "#2A3530"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.785 451.626L387.468 452.6L389.151 451.626H385.785Z",
    fill: "#2A3530"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.482 439.697V455.878L383.82 458.004V441.823L387.482 439.697Z",
    fill: "url(#paint75_linear_1509_12467)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.94 380.288L213.767 379.815L207.124 375.977L206.297 376.449L212.94 380.288Z",
    fill: "#63645C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.444 388.851L236.206 394.609L233.135 396.38L228.617 389.323L229.444 388.851Z",
    fill: "#4B5550"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.768 379.815L220.5 385.573L217.459 387.315L212.941 380.288L213.768 379.815Z",
    fill: "#4B5550"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.511 394.077L236.208 394.609L233.137 396.38L237.684 394.55L238.511 394.077Z",
    fill: "#63645C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.794 385.012L220.491 385.573L217.449 387.315L221.967 385.485L222.794 385.012Z",
    fill: "#63645C"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.123 375.977L204.406 376.597L200.922 378.605L206.296 376.449L207.123 375.977Z",
    fill: "#63645C"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.612 389.323L229.439 388.851L222.795 385.012L221.969 385.485L228.612 389.323Z",
    fill: "#63645C"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.323 398.388L245.15 397.916L238.477 394.077L237.68 394.55L244.323 398.388Z",
    fill: "#63645C"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.595 386.016C211.337 387.02 212.784 389.501 212.784 391.538C212.784 393.575 211.367 394.373 209.595 393.369C207.853 392.365 206.406 389.884 206.406 387.877C206.406 385.81 207.853 384.983 209.595 386.016Z",
    fill: "#E3D6C9"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.59 386.814C210.948 387.611 212.07 389.53 212.07 391.095C212.07 392.66 210.978 393.31 209.59 392.512C208.231 391.715 207.109 389.826 207.109 388.231C207.109 386.637 208.231 386.046 209.59 386.814Z",
    fill: "url(#paint76_linear_1509_12467)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.595 387.699C210.54 388.26 211.308 389.589 211.308 390.682C211.308 391.774 210.54 392.217 209.595 391.686C208.651 391.125 207.883 389.796 207.883 388.703C207.883 387.581 208.651 387.138 209.595 387.699Z",
    fill: "#E3D6C9"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.275 395.052C227.017 396.056 228.464 398.536 228.464 400.573C228.464 402.611 227.047 403.408 225.275 402.404C223.533 401.4 222.086 398.92 222.086 396.912C222.115 394.875 223.533 394.048 225.275 395.052Z",
    fill: "#E3D6C9"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.269 395.878C226.628 396.676 227.75 398.595 227.75 400.16C227.75 401.725 226.657 402.374 225.269 401.577C223.911 400.78 222.789 398.89 222.789 397.296C222.819 395.731 223.911 395.081 225.269 395.878Z",
    fill: "url(#paint77_linear_1509_12467)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.275 396.735C226.22 397.296 226.988 398.624 226.988 399.717C226.988 400.809 226.22 401.252 225.275 400.721C224.33 400.16 223.562 398.831 223.562 397.739C223.562 396.617 224.33 396.174 225.275 396.735Z",
    fill: "#E3D6C9"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.986 404.116C242.728 405.12 244.175 407.6 244.175 409.638C244.175 411.675 242.757 412.472 240.986 411.468C239.244 410.464 237.797 407.984 237.797 405.976C237.797 403.968 239.214 403.083 240.986 404.116Z",
    fill: "#E3D6C9"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.98 404.913C242.339 405.71 243.461 407.63 243.461 409.195C243.461 410.759 242.368 411.409 240.98 410.612C239.622 409.815 238.5 407.925 238.5 406.33C238.5 404.736 239.622 404.145 240.98 404.913Z",
    fill: "url(#paint78_linear_1509_12467)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.986 405.77C241.931 406.331 242.699 407.659 242.699 408.752C242.699 409.844 241.931 410.287 240.986 409.756C240.041 409.195 239.273 407.866 239.273 406.773C239.273 405.681 240.041 405.238 240.986 405.77Z",
    fill: "#E3D6C9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.081 444.45L324.878 443.978L318.235 440.139L317.438 440.612L324.081 444.45Z",
    fill: "#63645C"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.263 440.11L316.078 440.464L312.062 442.767L317.436 440.582L318.263 440.11Z",
    fill: "#63645C"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.879 443.978L332.911 450.799L329.456 452.807L324.082 444.45L324.879 443.978Z",
    fill: "#4B5550"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.121 397.916L253.153 404.737L249.669 406.745L244.324 398.388L245.121 397.916Z",
    fill: "#4B5550"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.922 441.232L313.184 441.646L313.597 441.882L314.306 441.469L313.922 441.232Z",
    fill: "url(#paint79_linear_1509_12467)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.605 302.484L341.936 390.416V442.915L189.605 354.954V302.484Z",
    fill: "#9A9DAF"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.32 434.943C332.733 435.179 333.176 435.445 333.59 435.681C333.59 436.478 333.59 437.276 333.59 438.073C333.176 437.837 332.733 437.571 332.32 437.335C332.32 436.537 332.32 435.74 332.32 434.943ZM325.263 430.868C325.676 431.104 326.119 431.37 326.533 431.606C326.533 432.404 326.533 433.201 326.533 433.998C326.119 433.762 325.676 433.496 325.263 433.26C325.263 432.463 325.263 431.665 325.263 430.868ZM318.176 426.793C318.59 427.03 319.033 427.295 319.446 427.532C319.446 428.329 319.446 429.126 319.446 429.923C319.033 429.687 318.59 429.421 318.176 429.185C318.176 428.388 318.176 427.591 318.176 426.793ZM311.119 422.719C311.533 422.955 311.976 423.221 312.389 423.457C312.389 424.254 312.389 425.051 312.389 425.849C311.976 425.612 311.533 425.347 311.119 425.11C311.119 424.313 311.119 423.516 311.119 422.719ZM304.033 418.614C304.446 418.851 304.889 419.116 305.302 419.353C305.302 420.15 305.302 420.947 305.302 421.744C304.889 421.508 304.446 421.242 304.033 421.006C304.033 420.209 304.033 419.412 304.033 418.614ZM296.976 414.54C297.389 414.776 297.832 415.042 298.245 415.278C298.245 416.075 298.245 416.872 298.245 417.669C297.832 417.433 297.389 417.167 296.976 416.931C296.976 416.134 296.976 415.337 296.976 414.54ZM289.889 410.465C290.303 410.701 290.746 410.967 291.159 411.203C291.159 412 291.159 412.797 291.159 413.595C290.746 413.358 290.303 413.093 289.889 412.856C289.889 412.059 289.889 411.262 289.889 410.465ZM282.832 406.36C283.246 406.597 283.689 406.862 284.102 407.099C284.102 407.896 284.102 408.693 284.102 409.49C283.689 409.254 283.246 408.988 282.832 408.752C282.832 407.984 282.832 407.158 282.832 406.36ZM275.746 402.286C276.159 402.522 276.602 402.788 277.015 403.024C277.015 403.821 277.015 404.618 277.015 405.416C276.602 405.179 276.159 404.914 275.746 404.677C275.746 403.88 275.746 403.083 275.746 402.286ZM268.689 398.211C269.102 398.447 269.545 398.713 269.958 398.949C269.958 399.746 269.958 400.544 269.958 401.341C269.545 401.105 269.102 400.839 268.689 400.603C268.689 399.806 268.689 399.008 268.689 398.211ZM261.602 394.136C262.016 394.373 262.458 394.638 262.872 394.874C262.872 395.672 262.872 396.469 262.872 397.266C262.458 397.03 262.016 396.764 261.602 396.528C261.602 395.731 261.602 394.934 261.602 394.136ZM254.545 390.032C254.959 390.268 255.401 390.534 255.815 390.77C255.815 391.567 255.815 392.365 255.815 393.162C255.401 392.926 254.959 392.66 254.545 392.424C254.545 391.626 254.545 390.829 254.545 390.032ZM247.459 385.957C247.872 386.193 248.315 386.459 248.728 386.695C248.728 387.493 248.728 388.29 248.728 389.087C248.315 388.851 247.872 388.585 247.459 388.349C247.459 387.552 247.459 386.754 247.459 385.957ZM240.402 381.882C240.815 382.119 241.258 382.384 241.671 382.621C241.671 383.418 241.671 384.215 241.671 385.012C241.258 384.776 240.815 384.51 240.402 384.274C240.402 383.477 240.402 382.68 240.402 381.882ZM233.315 377.808C233.728 378.044 234.171 378.31 234.585 378.546C234.585 379.343 234.585 380.14 234.585 380.938C234.171 380.701 233.728 380.436 233.315 380.199C233.315 379.402 233.315 378.605 233.315 377.808ZM226.258 373.703C226.671 373.94 227.115 374.205 227.528 374.441C227.528 375.239 227.528 376.036 227.528 376.833C227.115 376.597 226.671 376.331 226.258 376.095C226.258 375.298 226.258 374.501 226.258 373.703ZM219.172 369.629C219.585 369.865 220.028 370.13 220.441 370.367C220.441 371.164 220.441 371.961 220.441 372.758C220.028 372.522 219.585 372.256 219.172 372.02C219.172 371.223 219.172 370.426 219.172 369.629ZM212.115 365.554C212.528 365.79 212.971 366.056 213.384 366.292C213.384 367.089 213.384 367.887 213.384 368.684C212.971 368.448 212.528 368.182 212.115 367.946C212.115 367.148 212.115 366.351 212.115 365.554ZM205.028 361.479C205.442 361.715 205.884 361.981 206.298 362.217C206.298 363.015 206.298 363.812 206.298 364.609C205.884 364.373 205.442 364.107 205.028 363.871C205.028 363.074 205.028 362.276 205.028 361.479ZM197.971 357.375C198.384 357.611 198.827 357.877 199.241 358.113C199.241 358.91 199.241 359.707 199.241 360.505C198.827 360.268 198.384 360.003 197.971 359.767C197.971 358.969 197.971 358.172 197.971 357.375ZM190.914 353.3L192.184 354.038V356.43L190.914 355.692V353.3ZM339.406 439.047L340.676 439.785V442.177L339.406 441.439V439.047Z",
    fill: "#3A4440"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.757 275.85L189.605 302.483L341.936 390.416L388.088 363.782L235.757 275.85Z",
    fill: "#BCBDCF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M144.059 249.534C123.616 249.534 107.043 239.965 107.043 228.162C107.043 216.358 123.616 206.789 144.059 206.789C164.502 206.789 181.074 216.358 181.074 228.162C181.074 239.965 164.502 249.534 144.059 249.534Z",
    fill: "#39444F"
  }))), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M168.346 216.969L166.702 219.412C165.282 217.011 162.926 214.754 159.626 212.83C148.005 206.052 129.116 205.968 117.436 212.64C114.202 214.49 111.863 216.661 110.413 218.982L108.68 216.703L108.656 221.914L108.667 221.905C108.533 226.397 111.418 230.922 117.339 234.377C128.96 241.155 147.848 241.239 159.529 234.566C165.37 231.229 168.302 226.834 168.322 222.425L168.346 216.969Z",
    fill: "#F4A856"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M159.55 229.106C147.869 235.78 128.981 235.697 117.36 228.916C105.739 222.138 105.787 211.231 117.468 204.557C129.148 197.882 148.037 197.966 159.658 204.746C171.279 211.527 171.23 222.431 159.55 229.106Z",
    fill: "#FCCC6B"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M159.55 229.106C147.869 235.78 128.981 235.697 117.36 228.916C105.739 222.138 105.787 211.231 117.468 204.557C129.148 197.882 148.037 197.966 159.658 204.746C171.279 211.527 171.23 222.431 159.55 229.106Z",
    fill: "url(#paint80_radial_1509_12467)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M138.644 231.534C132.117 231.534 125.585 230.086 120.63 227.196C115.829 224.397 113.197 220.676 113.215 216.717C113.233 212.76 115.9 209.064 120.723 206.306C130.58 200.674 146.586 200.745 156.395 206.467C161.196 209.266 163.828 212.987 163.81 216.944C163.792 220.901 161.125 224.597 156.3 227.355C151.422 230.143 145.036 231.534 138.644 231.534ZM138.381 202.627C132.077 202.627 125.784 203.998 120.974 206.747C116.314 209.41 113.737 212.952 113.72 216.719C113.702 220.488 116.246 224.053 120.884 226.76C130.556 232.4 146.328 232.471 156.051 226.916C160.711 224.253 163.287 220.711 163.305 216.942C163.323 213.175 160.779 209.608 156.141 206.906C151.256 204.055 144.813 202.627 138.381 202.627Z",
    fill: "#F4A856"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M156.176 227.132C146.371 232.735 130.511 232.665 120.755 226.973C110.999 221.282 111.041 212.128 120.845 206.524C130.65 200.921 146.51 200.992 156.264 206.683C166.022 212.372 165.983 221.529 156.176 227.132Z",
    fill: "url(#paint81_radial_1509_12467)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M120.853 207.723C130.66 202.12 146.517 202.191 156.273 207.882C160.887 210.574 163.307 214.041 163.541 217.541C163.836 213.644 161.42 209.683 156.278 206.683C146.522 200.992 130.664 200.921 120.859 206.524C115.692 209.478 113.239 213.417 113.499 217.316C113.766 213.818 116.215 210.373 120.853 207.723Z",
    fill: "#F4A856"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M159.555 227.969C147.875 234.644 128.986 234.56 117.365 227.78C111.804 224.535 108.923 220.347 108.702 216.13C108.42 220.724 111.299 225.382 117.361 228.917C128.982 235.695 147.87 235.781 159.551 229.107C165.641 225.626 168.562 220.995 168.322 216.399C168.064 220.614 165.145 224.775 159.555 227.969Z",
    fill: "#FCE586"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M171.702 209.615L170.057 212.057C168.638 209.657 166.281 207.4 162.981 205.475C151.36 198.697 132.472 198.613 120.791 205.286C117.558 207.135 115.219 209.306 113.769 211.627L112.036 209.348L112.012 214.559L112.023 214.55C111.888 219.043 114.774 223.568 120.694 227.022C132.315 233.8 151.204 233.884 162.884 227.212C168.726 223.874 171.657 219.479 171.677 215.071L171.702 209.615Z",
    fill: "#F4A856"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M162.902 221.752C151.221 228.427 132.332 228.343 120.711 221.562C109.09 214.784 109.139 203.877 120.82 197.203C132.5 190.528 151.389 190.612 163.01 197.392C174.63 204.173 174.582 215.077 162.902 221.752Z",
    fill: "#FCCC6B"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M162.902 221.752C151.221 228.427 132.332 228.343 120.711 221.562C109.09 214.784 109.139 203.877 120.82 197.203C132.5 190.528 151.389 190.612 163.01 197.392C174.63 204.173 174.582 215.077 162.902 221.752Z",
    fill: "url(#paint82_radial_1509_12467)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M141.999 224.18C135.472 224.18 128.941 222.732 123.986 219.842C119.185 217.043 116.553 213.322 116.57 209.363C116.588 205.406 119.255 201.71 124.078 198.952C133.936 193.32 149.941 193.391 159.75 199.113C164.551 201.913 167.183 205.633 167.165 209.59C167.148 213.547 164.481 217.243 159.655 220.001C154.777 222.789 148.391 224.18 141.999 224.18ZM141.737 195.273C135.432 195.273 129.139 196.644 124.329 199.393C119.67 202.056 117.093 205.598 117.075 209.365C117.058 213.135 119.601 216.699 124.239 219.406C133.912 225.047 149.683 225.117 159.406 219.562C164.066 216.9 166.643 213.357 166.661 209.588C166.678 205.821 164.134 202.254 159.497 199.552C154.612 196.702 148.169 195.273 141.737 195.273Z",
    fill: "#F4A856"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M159.531 219.778C149.726 225.382 133.867 225.311 124.11 219.62C114.354 213.928 114.396 204.774 124.201 199.171C134.006 193.567 149.865 193.638 159.619 199.329C169.378 205.019 169.338 214.175 159.531 219.778Z",
    fill: "url(#paint83_radial_1509_12467)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M124.208 200.37C134.015 194.766 149.873 194.837 159.629 200.528C164.242 203.22 166.663 206.687 166.896 210.188C167.192 206.29 164.776 202.329 159.633 199.329C149.877 193.638 134.019 193.567 124.215 199.171C119.048 202.124 116.595 206.063 116.855 209.963C117.121 206.464 119.57 203.019 124.208 200.37Z",
    fill: "#F4A856"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M162.911 220.616C151.23 227.29 132.342 227.206 120.721 220.426C115.159 217.181 112.278 212.993 112.058 208.776C111.776 213.37 114.655 218.028 120.716 221.563C132.337 228.342 151.226 228.428 162.906 221.753C168.997 218.272 171.918 213.641 171.677 209.045C171.419 213.26 168.501 217.422 162.911 220.616Z",
    fill: "#FCE586"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M171.702 201.886L170.057 204.328C168.638 201.928 166.281 199.671 162.981 197.746C151.36 190.968 132.472 190.884 120.791 197.557C117.558 199.406 115.219 201.577 113.769 203.899L112.036 201.619L112.012 206.83L112.023 206.821C111.888 211.314 114.774 215.839 120.694 219.293C132.315 226.072 151.204 226.155 162.884 219.483C168.726 216.146 171.657 211.75 171.677 207.342L171.702 201.886Z",
    fill: "#F4A856"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M162.905 214.022C151.225 220.697 132.336 220.613 120.715 213.833C109.094 207.055 109.143 196.148 120.823 189.473C132.504 182.799 151.392 182.883 163.013 189.663C174.634 196.443 174.586 207.348 162.905 214.022Z",
    fill: "#FCCC6B"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M162.905 214.022C151.225 220.697 132.336 220.613 120.715 213.833C109.094 207.055 109.143 196.148 120.823 189.473C132.504 182.799 151.392 182.883 163.013 189.663C174.634 196.443 174.586 207.348 162.905 214.022Z",
    fill: "url(#paint84_radial_1509_12467)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M141.999 216.451C135.472 216.451 128.941 215.003 123.986 212.113C119.185 209.313 116.553 205.592 116.57 201.634C116.588 197.677 119.255 193.98 124.078 191.223C133.936 185.591 149.941 185.661 159.75 191.384C164.551 194.183 167.183 197.904 167.165 201.861C167.148 205.817 164.481 209.514 159.655 212.271C154.777 215.06 148.391 216.451 141.999 216.451ZM141.737 187.544C135.432 187.544 129.139 188.915 124.329 191.664C119.67 194.326 117.093 197.869 117.075 201.636C117.058 205.405 119.601 208.969 124.239 211.676C133.912 217.317 149.683 217.388 159.406 211.833C164.066 209.17 166.643 205.628 166.661 201.858C166.678 198.091 164.134 194.525 159.497 191.822C154.612 188.972 148.169 187.544 141.737 187.544Z",
    fill: "#F4A856"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M159.531 212.05C149.726 217.653 133.867 217.582 124.11 211.891C114.354 206.199 114.396 197.045 124.201 191.442C134.006 185.838 149.865 185.909 159.619 191.601C169.378 197.29 169.338 206.446 159.531 212.05Z",
    fill: "url(#paint85_radial_1509_12467)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M124.208 192.641C134.015 187.038 149.873 187.108 159.629 192.8C164.242 195.491 166.663 198.958 166.896 202.459C167.192 198.562 164.776 194.601 159.633 191.601C149.877 185.909 134.019 185.838 124.215 191.442C119.048 194.395 116.595 198.335 116.855 202.234C117.121 198.736 119.57 195.29 124.208 192.641Z",
    fill: "#F4A856"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M162.911 212.887C151.23 219.561 132.342 219.478 120.721 212.697C115.159 209.452 112.278 205.264 112.058 201.047C111.776 205.641 114.655 210.299 120.716 213.835C132.337 220.613 151.226 220.699 162.906 214.024C168.997 210.544 171.918 205.912 171.677 201.316C171.419 205.531 168.501 209.693 162.911 212.887Z",
    fill: "#FCE586"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M165.803 192.367L164.159 194.809C162.739 192.409 160.383 190.151 157.083 188.227C145.462 181.449 126.573 181.365 114.893 188.037C111.659 189.887 109.321 192.058 107.87 194.379L106.137 192.1L106.113 197.311L106.124 197.302C105.99 201.794 108.875 206.32 114.796 209.774C126.417 216.552 145.305 216.636 156.986 209.963C162.827 206.626 165.759 202.231 165.779 197.822L165.803 192.367Z",
    fill: "#F4A856"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M157.007 204.502C145.326 211.177 126.438 211.093 114.817 204.313C103.196 197.534 103.244 186.628 114.925 179.953C126.605 173.278 145.494 173.362 157.115 180.143C168.736 186.923 168.688 197.828 157.007 204.502Z",
    fill: "#FCCC6B"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M157.007 204.502C145.326 211.177 126.438 211.093 114.817 204.313C103.196 197.534 103.244 186.628 114.925 179.953C126.605 173.278 145.494 173.362 157.115 180.143C168.736 186.923 168.688 197.828 157.007 204.502Z",
    fill: "url(#paint86_radial_1509_12467)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M136.101 206.931C129.574 206.931 123.042 205.483 118.087 202.593C113.286 199.794 110.654 196.073 110.672 192.114C110.69 188.157 113.357 184.461 118.18 181.703C128.037 176.071 144.043 176.142 153.852 181.864C158.653 184.664 161.285 188.384 161.267 192.341C161.249 196.298 158.582 199.994 153.757 202.752C148.879 205.54 142.493 206.931 136.101 206.931ZM135.838 178.024C129.534 178.024 123.241 179.395 118.431 182.144C113.771 184.807 111.194 188.349 111.177 192.116C111.159 195.886 113.703 199.45 118.341 202.157C128.013 207.798 143.785 207.868 153.508 202.313C158.168 199.651 160.744 196.108 160.762 192.339C160.78 188.572 158.236 185.005 153.598 182.303C148.714 179.453 142.27 178.024 135.838 178.024Z",
    fill: "#F4A856"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M153.633 202.529C143.828 208.132 127.968 208.062 118.212 202.37C108.456 196.679 108.498 187.524 118.302 181.921C128.107 176.318 143.967 176.388 153.721 182.08C163.479 187.769 163.44 196.926 153.633 202.529Z",
    fill: "url(#paint87_radial_1509_12467)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M118.31 183.12C128.117 177.517 143.974 177.587 153.73 183.279C158.344 185.97 160.764 189.438 160.998 192.938C161.293 189.041 158.877 185.08 153.735 182.08C143.979 176.388 128.121 176.318 118.316 181.921C113.149 184.875 110.696 188.814 110.956 192.713C111.223 189.215 113.672 185.77 118.31 183.12Z",
    fill: "#F4A856"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M157.012 203.367C145.332 210.041 126.443 209.958 114.822 203.177C109.261 199.933 106.38 195.744 106.16 191.528C105.877 196.121 108.756 200.779 114.818 204.315C126.439 211.093 145.327 211.179 157.008 204.504C163.098 201.024 166.019 196.392 165.779 191.796C165.521 196.011 162.602 200.173 157.012 203.367Z",
    fill: "#FCE586"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M167.512 155.043L167.3 157.78C165.046 156.486 162.097 155.738 158.536 155.693C145.996 155.536 130.638 164.15 124.234 174.93C122.46 177.915 121.562 180.753 121.453 183.301L119 182.249L121.375 186.486L121.379 186.476C123.336 190.18 127.755 192.525 134.144 192.605C146.684 192.761 162.042 184.147 168.447 173.368C171.65 167.976 172.008 163.065 169.998 159.482L167.512 155.043Z",
    fill: "#F4A856"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M165.965 168.933C159.56 179.715 144.2 188.328 131.662 188.172C119.121 188.016 114.149 179.15 120.554 168.368C126.958 157.586 142.318 148.973 154.856 149.131C167.397 149.285 172.369 158.154 165.965 168.933Z",
    fill: "#FCCC6B"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M165.965 168.933C159.56 179.715 144.2 188.328 131.662 188.172C119.121 188.016 114.149 179.15 120.554 168.368C126.958 157.586 142.318 148.973 154.856 149.131C167.397 149.285 172.369 158.154 165.965 168.933Z",
    fill: "url(#paint88_radial_1509_12467)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M150.121 180.511C144.828 183.511 138.865 185.338 133.518 185.272C128.338 185.209 124.493 183.4 122.687 180.183C120.883 176.965 121.347 172.742 123.992 168.289C129.398 159.191 142.409 151.892 152.995 152.024C158.176 152.087 162.02 153.896 163.824 157.111C165.628 160.329 165.164 164.552 162.519 169.004C159.846 173.511 155.307 177.573 150.121 180.511ZM136.623 157.189C131.51 160.087 127.037 164.089 124.399 168.532C121.843 172.833 121.38 176.891 123.098 179.955C124.816 183.018 128.519 184.742 133.522 184.804C143.958 184.933 156.782 177.742 162.115 168.768C164.671 164.467 165.133 160.409 163.413 157.346C161.696 154.282 157.993 152.56 152.989 152.498C147.721 152.428 141.84 154.233 136.623 157.189Z",
    fill: "#F4A856"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M162.322 168.892C156.944 177.943 144.05 185.174 133.524 185.043C122.997 184.911 118.821 177.467 124.199 168.417C129.576 159.366 142.47 152.135 152.997 152.266C163.524 152.398 167.699 159.84 162.322 168.892Z",
    fill: "url(#paint89_radial_1509_12467)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M124.744 169.393C130.121 160.342 143.015 153.111 153.542 153.242C158.521 153.304 162.078 155.003 163.876 157.734C162.324 154.438 158.543 152.336 152.995 152.266C142.469 152.135 129.575 159.366 124.197 168.417C121.364 173.186 121.185 177.51 123.188 180.551C121.797 177.594 122.202 173.675 124.744 169.393Z",
    fill: "#F4A856"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M165.445 168.005C159.04 178.786 143.68 187.4 131.142 187.242C125.142 187.168 120.878 185.094 118.762 181.774C120.644 185.629 125.121 188.082 131.66 188.164C144.2 188.32 159.558 179.709 165.963 168.927C169.304 163.305 169.542 158.207 167.234 154.591C168.963 158.129 168.51 162.845 165.445 168.005Z",
    fill: "#FCE586"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M171.873 125.798L169.231 126.54C169.671 123.98 169.36 120.954 168.178 117.593C164.014 105.764 150.645 94.3032 138.319 91.9945C134.906 91.3548 131.932 91.4878 129.503 92.2608L129.648 89.5959L126.487 93.2831L126.5 93.2834C123.694 96.3944 123.012 101.35 125.132 107.378C129.296 119.207 142.665 130.668 154.991 132.976C161.156 134.131 165.89 132.777 168.566 129.658L171.873 125.798Z",
    fill: "#F4A856"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M171.905 125.783C177.677 119.05 172.903 105.488 161.242 95.4915C149.581 85.4946 135.449 82.8483 129.677 89.5809C123.906 96.3134 128.68 109.875 140.34 119.872C152.001 129.869 166.133 132.515 171.905 125.783Z",
    fill: "#FCCC6B"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M158.306 129.111C145.98 126.802 132.611 115.341 128.447 103.513C124.283 91.6845 130.9 83.9647 143.226 86.2733C155.552 88.5819 168.921 100.043 173.085 111.872C177.249 123.7 170.633 131.418 158.306 129.111Z",
    fill: "url(#paint90_radial_1509_12467)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M141.975 118.231C137.339 114.292 133.572 109.321 131.796 104.277C130.076 99.3902 130.452 95.1585 132.851 92.3567C135.252 89.5573 139.378 88.5386 144.468 89.4934C154.871 91.4418 166.197 101.151 169.714 111.138C171.434 116.025 171.058 120.256 168.659 123.056C166.258 125.855 162.132 126.874 157.042 125.919C151.894 124.955 146.516 122.09 141.975 118.231ZM159.237 97.5364C154.758 93.7321 149.461 90.9067 144.383 89.9563C139.465 89.0344 135.498 89.9958 133.211 92.6621C130.923 95.3305 130.579 99.3966 132.24 104.119C135.707 113.965 146.869 123.534 157.129 125.455C162.047 126.377 166.016 125.416 168.302 122.747C170.588 120.08 170.932 116.012 169.27 111.293C167.52 106.322 163.804 101.419 159.237 97.5364Z",
    fill: "#F4A856"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M157.087 125.686C146.738 123.748 135.516 114.128 132.021 104.196C128.524 94.2651 134.079 87.7853 144.428 89.7233C154.777 91.6612 165.998 101.282 169.494 111.214C172.991 121.143 167.434 127.624 157.087 125.686Z",
    fill: "url(#paint91_radial_1509_12467)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M143.701 90.5647C154.05 92.5026 165.272 102.123 168.768 112.054C170.422 116.752 170.049 120.674 168.102 123.301C170.663 120.71 171.338 116.438 169.494 111.205C165.997 101.275 154.774 91.6518 144.427 89.7142C138.974 88.6938 134.855 90.0111 132.687 92.9388C134.988 90.6161 138.807 89.6495 143.701 90.5647Z",
    fill: "#F4A856"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M158.991 128.319C146.665 126.011 133.296 114.55 129.132 102.721C127.14 97.0606 127.621 92.3449 130.01 89.2148C127.036 92.3081 126.272 97.3544 128.443 103.524C132.606 115.353 145.975 126.814 158.302 129.122C164.731 130.326 169.599 128.799 172.203 125.387C169.474 128.228 164.889 129.425 158.991 128.319Z",
    fill: "#FCE586"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M174.26 116.821C173.043 116.384 168.056 112.944 158.328 106.669C149.318 100.859 147.681 99.3226 144.331 96.7895C145.807 94.8196 153.83 90.3608 162.409 96.7902C171.521 103.962 174.26 114.666 174.26 116.821Z",
    fill: "#F4A856",
    fillOpacity: 0.5
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M181.03 52.4372L181.879 55.1643C179.203 54.7803 176.065 55.1927 172.605 56.5199C160.425 61.195 148.896 75.4322 146.855 88.3185C146.289 91.8861 146.515 94.9757 147.388 97.4789L144.612 97.4065L148.54 100.588L148.54 100.574C151.856 103.402 157.031 103.966 163.236 101.584C175.417 96.9089 186.945 82.6717 188.986 69.7854C190.007 63.3423 188.461 58.4565 185.14 55.7664L181.03 52.4372Z",
    fill: "#F4A856"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M184.875 66.455C182.834 79.3412 171.305 93.5785 159.125 98.2536C146.944 102.929 138.724 96.2725 140.765 83.3862C142.806 70.4999 154.335 56.2627 166.516 51.5876C178.696 46.9124 186.916 53.5687 184.875 66.455Z",
    fill: "#FCCC6B"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M184.875 66.455C182.834 79.3412 171.305 93.5785 159.125 98.2536C146.944 102.929 138.724 96.2725 140.765 83.3862C142.806 70.4999 154.335 56.2627 166.516 51.5876C178.696 46.9124 186.916 53.5687 184.875 66.455Z",
    fill: "url(#paint92_radial_1509_12467)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M174.025 83.7484C170.065 88.6835 165.005 92.7477 159.809 94.7399C154.779 96.6712 150.366 96.4038 147.382 93.9891C144.401 91.5737 143.223 87.3136 144.064 81.9901C145.786 71.1141 155.554 59.0528 165.837 55.1052C170.868 53.1739 175.281 53.4413 178.264 55.854C181.245 58.2693 182.423 62.5314 181.58 67.8536C180.728 73.2384 177.906 78.9131 174.025 83.7484ZM152 66.4023C148.173 71.1721 145.392 76.7628 144.551 82.0708C143.735 87.2125 144.851 91.3105 147.69 93.6102C150.532 95.9114 154.771 96.1509 159.632 94.2845C169.769 90.3922 179.397 78.5048 181.095 67.779C181.91 62.6373 180.795 58.5393 177.953 56.2381C175.114 53.9383 170.873 53.6994 166.014 55.5653C160.895 57.53 155.905 61.5373 152 66.4023Z",
    fill: "#F4A856"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M181.34 67.8103C179.627 78.6277 169.947 90.5799 159.722 94.5055C149.496 98.4311 142.595 92.8435 144.308 82.0261C146.021 71.2088 155.701 59.2565 165.926 55.3309C176.152 51.4053 183.053 56.993 181.34 67.8103Z",
    fill: "url(#paint93_radial_1509_12467)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M145.212 82.7577C146.925 71.9404 156.605 59.9881 166.83 56.0625C171.667 54.2055 175.759 54.4808 178.547 56.4274C175.779 53.8382 171.315 53.2623 165.926 55.3309C155.701 59.2566 146.023 71.2082 144.308 82.0261C143.405 87.728 144.896 91.9739 148.003 94.1433C145.521 91.8184 144.4 87.8738 145.212 82.7577Z",
    fill: "#F4A856"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M184.023 65.7595C181.982 78.6458 170.453 92.883 158.273 97.5582C152.444 99.7956 147.526 99.4327 144.203 97.0381C147.506 100.039 152.778 100.688 159.13 98.2505C171.31 93.5754 182.839 79.3382 184.88 66.4519C185.944 59.732 184.215 54.7118 180.591 52.1045C183.621 54.8601 184.998 59.5937 184.023 65.7595Z",
    fill: "#FCE586"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M138.82 324.56C152.971 319.057 153.757 301.919 121.368 289.812C88.9783 278.177 55.1739 287.454 41.1804 305.064C27.187 322.675 35.0485 339.812 54.8594 339.812C74.6703 339.812 79.23 333.523 92.1229 327.548C105.016 321.573 124.67 330.063 138.82 324.56Z",
    fill: "#39444F"
  }))), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6367 303.045L101.032 301.48L99.653 298.521L96.924 300.963L96.6367 303.045Z",
    fill: "#21272F"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2733 295.152C92.2733 295.152 92.0435 298.025 92.0004 298.858C91.9573 299.691 95.7059 302.578 96.6395 303.052L96.9267 300.969C97.7771 302.009 98.4914 303.153 99.0524 304.373C99.8868 306.38 101.112 308.201 102.657 309.73C105.602 312.215 110.255 313.522 115.009 313.766C119.763 314.01 122.506 312.904 123.871 311.899C124.455 311.57 124.917 311.06 125.189 310.447C125.461 309.834 125.527 309.149 125.379 308.495C125.048 307.303 92.2733 295.152 92.2733 295.152Z",
    fill: "#364959"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M105.156 285.764L105.243 284.126C106.119 284.126 106.176 286.482 107.426 288.579C109.235 291.721 111.441 294.617 113.989 297.196C118.743 301.649 122.995 304.464 125.12 306.475C127.993 309.16 122.822 313.254 115.067 312.694C111.217 312.421 104.395 310.381 102.514 308.083C100.632 305.785 99.4976 302.238 97.9896 300.557C96.4815 298.877 93.1925 297.168 92.2446 295.157C91.7275 294.051 92.0435 291.494 92.4026 289.326C92.7616 287.157 92.8334 284.27 93.9681 284.543V285.563C94.4133 286.453 95.4043 287.904 98.5641 288.435C100.259 288.766 104.826 288.981 105.156 285.764Z",
    fill: "#37474F"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M101.149 288.632C101.88 288.661 102.606 288.504 103.259 288.175C103.913 287.845 104.471 287.355 104.883 286.75C104.786 287.315 104.821 287.893 104.986 288.442C105.15 288.99 105.439 289.493 105.831 289.91C107.267 291.548 115.77 303.095 115.77 303.095C115.77 303.095 107.77 293.558 106.233 291.763C103.949 289.106 103.231 288.776 101.105 288.675L101.149 288.632Z",
    fill: "#21272F"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M103.028 291.639C103.01 291.763 102.944 291.876 102.845 291.954C102.746 292.031 102.621 292.068 102.496 292.055C102.373 292.037 102.261 291.972 102.186 291.872C102.111 291.773 102.078 291.648 102.094 291.524C102.101 291.461 102.121 291.401 102.151 291.346C102.182 291.291 102.223 291.243 102.273 291.204C102.322 291.166 102.379 291.137 102.439 291.12C102.5 291.104 102.563 291.099 102.625 291.107C102.749 291.125 102.86 291.191 102.936 291.29C103.011 291.39 103.044 291.515 103.028 291.639Z",
    fill: "#21272F"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M105.28 294.193C105.264 294.318 105.2 294.433 105.1 294.511C105 294.589 104.874 294.624 104.748 294.609C104.622 294.594 104.508 294.529 104.43 294.43C104.352 294.33 104.316 294.203 104.332 294.078C104.339 294.015 104.359 293.955 104.39 293.901C104.42 293.846 104.462 293.798 104.511 293.759C104.56 293.721 104.617 293.692 104.677 293.675C104.738 293.658 104.801 293.654 104.863 293.661C104.925 293.669 104.985 293.688 105.04 293.719C105.095 293.75 105.143 293.791 105.181 293.841C105.22 293.89 105.249 293.946 105.265 294.007C105.282 294.067 105.287 294.13 105.28 294.193Z",
    fill: "#21272F"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M107.538 296.752C107.531 296.814 107.511 296.875 107.481 296.93C107.45 296.984 107.409 297.033 107.359 297.071C107.31 297.11 107.253 297.139 107.193 297.155C107.132 297.172 107.069 297.177 107.006 297.169C106.944 297.161 106.884 297.142 106.829 297.111C106.774 297.081 106.726 297.039 106.687 296.99C106.648 296.94 106.62 296.884 106.603 296.823C106.586 296.763 106.582 296.699 106.59 296.637C106.597 296.575 106.616 296.515 106.647 296.461C106.678 296.407 106.719 296.359 106.769 296.322C106.819 296.284 106.876 296.257 106.936 296.242C106.997 296.227 107.06 296.225 107.121 296.235C107.245 296.249 107.357 296.312 107.435 296.408C107.513 296.505 107.55 296.628 107.538 296.752Z",
    fill: "#21272F"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M109.779 299.333C109.761 299.457 109.695 299.568 109.596 299.643C109.496 299.719 109.371 299.752 109.248 299.735C109.154 299.723 109.067 299.683 108.997 299.621C108.926 299.559 108.876 299.477 108.852 299.386C108.828 299.295 108.831 299.199 108.862 299.111C108.893 299.022 108.949 298.944 109.024 298.887C109.099 298.831 109.189 298.798 109.283 298.792C109.377 298.787 109.47 298.809 109.551 298.857C109.632 298.905 109.697 298.976 109.737 299.06C109.778 299.145 109.792 299.24 109.779 299.333Z",
    fill: "#21272F"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M112.029 301.901C112.011 302.025 111.945 302.136 111.846 302.212C111.746 302.287 111.621 302.32 111.498 302.304C111.404 302.291 111.317 302.251 111.247 302.189C111.176 302.127 111.126 302.045 111.102 301.955C111.078 301.864 111.081 301.768 111.112 301.679C111.143 301.59 111.199 301.512 111.274 301.456C111.349 301.399 111.439 301.366 111.533 301.36C111.627 301.355 111.72 301.378 111.801 301.425C111.882 301.473 111.947 301.544 111.987 301.629C112.028 301.713 112.042 301.808 112.029 301.901Z",
    fill: "#21272F"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M102.542 291.777C102.524 291.786 102.504 291.791 102.484 291.791C102.464 291.791 102.445 291.786 102.427 291.777C102.394 291.742 102.375 291.696 102.375 291.648C102.375 291.6 102.394 291.553 102.427 291.519C103.906 290.175 105.844 289.45 107.842 289.493C107.891 289.493 107.939 289.513 107.974 289.548C108.009 289.583 108.029 289.631 108.029 289.68C108.029 289.73 108.009 289.777 107.974 289.812C107.939 289.847 107.891 289.867 107.842 289.867C105.955 289.837 104.127 290.525 102.729 291.792C102.699 291.805 102.666 291.81 102.633 291.807C102.601 291.805 102.569 291.795 102.542 291.777Z",
    fill: "#364959"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M104.791 294.362C104.754 294.375 104.714 294.375 104.676 294.362C104.658 294.344 104.643 294.323 104.633 294.3C104.622 294.276 104.617 294.251 104.617 294.225C104.617 294.2 104.622 294.174 104.633 294.151C104.643 294.127 104.658 294.106 104.676 294.089C106.156 292.756 108.086 292.032 110.077 292.064C110.125 292.071 110.169 292.095 110.201 292.132C110.233 292.169 110.25 292.216 110.249 292.265C110.248 292.291 110.241 292.316 110.229 292.339C110.217 292.362 110.2 292.382 110.18 292.398C110.159 292.415 110.136 292.426 110.111 292.433C110.086 292.44 110.06 292.441 110.034 292.437C108.151 292.429 106.331 293.114 104.921 294.362C104.879 294.377 104.833 294.377 104.791 294.362Z",
    fill: "#364959"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M107.047 296.886C107.027 296.896 107.005 296.902 106.982 296.902C106.96 296.902 106.938 296.896 106.918 296.886C106.899 296.87 106.885 296.85 106.875 296.828C106.865 296.806 106.859 296.781 106.859 296.757C106.859 296.733 106.865 296.708 106.875 296.686C106.885 296.664 106.899 296.644 106.918 296.628C108.388 295.28 110.324 294.554 112.318 294.603C112.368 294.603 112.415 294.622 112.45 294.657C112.485 294.692 112.505 294.74 112.505 294.789C112.505 294.839 112.485 294.886 112.45 294.921C112.415 294.956 112.368 294.976 112.318 294.976C110.433 294.957 108.61 295.644 107.205 296.901C107.18 296.914 107.152 296.92 107.124 296.917C107.096 296.915 107.069 296.904 107.047 296.886Z",
    fill: "#364959"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M109.289 299.461H109.174C109.14 299.424 109.121 299.375 109.121 299.325C109.121 299.274 109.14 299.225 109.174 299.188C110.652 297.817 112.603 297.07 114.618 297.106C114.666 297.113 114.71 297.137 114.742 297.174C114.774 297.211 114.791 297.258 114.791 297.307C114.789 297.331 114.782 297.355 114.771 297.377C114.76 297.399 114.744 297.419 114.726 297.435C114.707 297.451 114.685 297.463 114.662 297.47C114.639 297.478 114.614 297.481 114.589 297.479C112.706 297.467 110.884 298.153 109.476 299.404C109.452 299.427 109.422 299.445 109.39 299.455C109.357 299.465 109.323 299.467 109.289 299.461Z",
    fill: "#364959"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M111.545 302.012C111.507 302.02 111.468 302.02 111.43 302.012C111.412 301.994 111.397 301.973 111.387 301.95C111.376 301.926 111.371 301.901 111.371 301.875C111.371 301.85 111.376 301.824 111.387 301.801C111.397 301.777 111.412 301.756 111.43 301.739C112.902 300.393 114.837 299.668 116.831 299.714C116.879 299.721 116.923 299.745 116.955 299.782C116.987 299.819 117.004 299.866 117.003 299.915C116.996 299.965 116.97 300.012 116.93 300.044C116.89 300.076 116.839 300.091 116.788 300.087C114.905 300.079 113.085 300.764 111.675 302.012C111.633 302.027 111.587 302.027 111.545 302.012Z",
    fill: "#364959"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9923 314.5C72.0278 317.444 71.3162 320.35 69.9241 322.945C69.2159 323.912 68.2572 324.668 67.1513 325.132C66.0453 325.595 64.834 325.747 63.6477 325.573C61.8995 325.449 60.225 324.819 58.8278 323.761C57.4306 322.703 56.3708 321.262 55.7771 319.613C54.8644 316.744 54.7453 313.682 55.4324 310.751L71.9923 314.5Z",
    fill: "#364959"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1924 287.392C59.1439 287.478 58.8711 292.505 58.3109 297.546C57.7077 302.961 56.0704 305.991 55.5533 309.625C54.8495 314.681 55.223 316.95 56.9896 319.995C58.7561 323.04 66.5406 326.027 69.6142 321.618C72.1133 318.027 72.1851 314.063 71.9122 309.022C71.6393 303.981 71.3951 300.146 71.5675 296.182C71.7398 292.218 71.9697 288.713 71.0648 288.311C70.993 288.857 70.9355 289.575 70.8637 290.121C70.7919 290.666 70.7201 292.591 70.1312 292.605C70.0871 292.128 70.0871 291.647 70.1312 291.169C70.1936 290.741 70.091 290.304 69.844 289.948C69.5173 289.656 69.1034 289.479 68.6663 289.446C67.6327 289.233 66.5871 289.084 65.5353 289C65.009 288.971 64.4816 288.971 63.9554 289C63.0338 288.977 62.1118 289.025 61.1978 289.144C61.0724 289.184 60.9574 289.251 60.8606 289.341C60.7639 289.43 60.6878 289.539 60.6376 289.661C60.6091 289.852 60.6091 290.045 60.6376 290.236C60.638 290.584 60.5946 290.932 60.5084 291.27C60.5084 291.428 60.3647 291.614 60.2211 291.571C60.0775 291.528 60.0488 291.399 60.0488 291.27C60.0488 290.666 60.0488 290.221 60.1349 289.503C60.1349 289.173 60.1349 288.728 60.1349 288.397C60.1349 288.067 60.1637 287.708 60.1924 287.392Z",
    fill: "#37474F"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M59.4036 310.85C59.3955 310.947 59.4256 311.043 59.4874 311.119C59.5493 311.194 59.638 311.242 59.7348 311.253C59.7891 311.264 59.8451 311.263 59.8988 311.249C59.9525 311.236 60.0026 311.21 60.0453 311.175C60.0881 311.14 60.1226 311.096 60.1463 311.046C60.1699 310.996 60.1822 310.941 60.1822 310.886C60.1822 310.831 60.1699 310.776 60.1463 310.726C60.1226 310.676 60.0881 310.632 60.0453 310.596C60.0026 310.561 59.9525 310.536 59.8988 310.523C59.8451 310.509 59.7891 310.508 59.7348 310.519C59.6502 310.528 59.5712 310.566 59.511 310.626C59.4508 310.686 59.413 310.765 59.4036 310.85Z",
    fill: "#21272F"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M59.7445 307.312C59.7362 307.386 59.7501 307.461 59.7846 307.527C59.819 307.593 59.8724 307.648 59.9378 307.683C60.0033 307.719 60.0779 307.734 60.152 307.727C60.2262 307.72 60.2966 307.691 60.3542 307.644C60.4117 307.596 60.4539 307.533 60.4752 307.462C60.4966 307.39 60.4961 307.314 60.474 307.243C60.4518 307.172 60.4089 307.109 60.3507 307.062C60.2926 307.016 60.2219 306.987 60.1477 306.981C60.0993 306.975 60.0501 306.979 60.0033 306.993C59.9564 307.006 59.9128 307.029 59.875 307.06C59.8373 307.091 59.8064 307.13 59.7839 307.173C59.7615 307.216 59.7481 307.264 59.7445 307.312Z",
    fill: "#21272F"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M60.0408 304.065C60.0263 304.118 60.0235 304.173 60.0325 304.227C60.0416 304.28 60.0623 304.332 60.0932 304.376C60.1241 304.421 60.1645 304.459 60.2115 304.487C60.2584 304.514 60.3109 304.532 60.3652 304.537C60.4195 304.542 60.4743 304.536 60.5257 304.518C60.5772 304.499 60.6241 304.47 60.6631 304.432C60.7022 304.394 60.7324 304.348 60.7518 304.297C60.7711 304.246 60.7791 304.191 60.7751 304.137C60.7832 304.04 60.7531 303.944 60.6913 303.868C60.6295 303.793 60.5407 303.745 60.4439 303.734C60.3468 303.726 60.2504 303.756 60.1751 303.818C60.0999 303.879 60.0517 303.968 60.0408 304.065Z",
    fill: "#21272F"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M60.3461 300.825C60.3378 300.899 60.3517 300.974 60.3862 301.04C60.4206 301.106 60.474 301.16 60.5394 301.196C60.6049 301.231 60.6795 301.246 60.7536 301.239C60.8278 301.232 60.8982 301.203 60.9557 301.156C61.0133 301.109 61.0554 301.045 61.0768 300.974C61.0981 300.902 61.0977 300.826 61.0755 300.755C61.0533 300.684 61.0105 300.621 60.9523 300.575C60.8942 300.528 60.8235 300.5 60.7493 300.494C60.6522 300.486 60.5558 300.516 60.4805 300.577C60.4052 300.639 60.357 300.728 60.3461 300.825Z",
    fill: "#21272F"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M68.6668 301.24C68.6608 301.289 68.6647 301.338 68.6783 301.385C68.6919 301.432 68.7149 301.475 68.7459 301.513C68.7768 301.551 68.8152 301.582 68.8585 301.604C68.9018 301.627 68.9493 301.64 68.998 301.643C69.086 301.637 69.1689 301.6 69.2321 301.538C69.2952 301.476 69.3346 301.394 69.3432 301.307C69.3519 301.219 69.3291 301.131 69.2791 301.058C69.2291 300.985 69.155 300.933 69.0699 300.909C68.9729 300.901 68.8764 300.931 68.8011 300.993C68.7259 301.055 68.6777 301.144 68.6668 301.24Z",
    fill: "#21272F"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M68.3777 304.518C68.3717 304.567 68.3757 304.616 68.3893 304.663C68.4029 304.71 68.4258 304.753 68.4568 304.791C68.4878 304.829 68.5261 304.86 68.5695 304.882C68.6128 304.904 68.6602 304.918 68.7089 304.921C68.806 304.929 68.9024 304.899 68.9777 304.838C69.053 304.776 69.1011 304.687 69.112 304.59C69.1202 304.493 69.0901 304.397 69.0283 304.321C68.9664 304.246 68.8777 304.198 68.7809 304.187C68.7324 304.181 68.6833 304.185 68.6364 304.199C68.5896 304.212 68.546 304.235 68.5083 304.266C68.4706 304.297 68.4395 304.335 68.4171 304.379C68.3946 304.422 68.3812 304.47 68.3777 304.518Z",
    fill: "#21272F"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M68.0559 307.834C68.0519 307.882 68.0579 307.931 68.0733 307.977C68.0887 308.023 68.1133 308.066 68.1456 308.102C68.1779 308.138 68.2172 308.168 68.2612 308.189C68.3052 308.209 68.3529 308.221 68.4015 308.223C68.4969 308.223 68.5884 308.185 68.656 308.117C68.7235 308.05 68.7614 307.958 68.7614 307.863C68.7614 307.767 68.7235 307.676 68.656 307.608C68.5884 307.541 68.4969 307.503 68.4015 307.503C68.3142 307.509 68.2319 307.545 68.1688 307.606C68.1057 307.666 68.0657 307.747 68.0559 307.834Z",
    fill: "#21272F"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M67.7435 311.295C67.7354 311.392 67.7654 311.489 67.8273 311.564C67.8891 311.639 67.9779 311.688 68.0747 311.699C68.1487 311.707 68.2236 311.693 68.2896 311.658C68.3557 311.624 68.41 311.571 68.4455 311.505C68.4811 311.44 68.4963 311.365 68.4892 311.291C68.4822 311.217 68.4531 311.146 68.4058 311.089C68.3586 311.031 68.2952 310.989 68.2238 310.968C68.1524 310.946 68.0763 310.947 68.0052 310.969C67.934 310.991 67.8711 311.034 67.8245 311.092C67.7779 311.15 67.7497 311.221 67.7435 311.295Z",
    fill: "#21272F"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M64.6406 312.99L67.269 288.617L65.9189 288.602L64.6406 312.99Z",
    fill: "#21272F"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7718 311.065C62.4972 310.513 65.3179 310.656 67.9732 311.482C67.9946 311.494 68.0183 311.501 68.0427 311.503C68.0671 311.505 68.0917 311.502 68.1148 311.494C68.1379 311.486 68.159 311.473 68.1767 311.456C68.1944 311.439 68.2083 311.418 68.2174 311.396C68.2294 311.374 68.2367 311.351 68.2388 311.326C68.2409 311.302 68.2377 311.277 68.2296 311.254C68.2214 311.231 68.2084 311.21 68.1915 311.192C68.1745 311.174 68.154 311.161 68.1312 311.151C65.4012 310.279 62.4923 310.126 59.6857 310.706C59.6385 310.717 59.5972 310.745 59.5704 310.785C59.5436 310.825 59.5335 310.874 59.542 310.922C59.5448 310.948 59.5535 310.973 59.5674 310.995C59.5812 311.017 59.5999 311.035 59.6221 311.049C59.6442 311.063 59.6691 311.072 59.6951 311.075C59.721 311.077 59.7473 311.074 59.7718 311.065Z",
    fill: "#364959"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M60.045 307.579H60.1456C61.9983 306.688 66.4507 307.133 68.3035 308.009C68.3495 308.03 68.4017 308.033 68.4496 308.017C68.4975 308.001 68.5376 307.968 68.562 307.923C68.582 307.879 68.5842 307.829 68.5681 307.784C68.5521 307.738 68.519 307.701 68.4758 307.679C66.5225 306.76 61.9265 306.243 59.9876 307.234C59.9644 307.245 59.9436 307.26 59.9266 307.279C59.9095 307.298 59.8965 307.32 59.8885 307.345C59.8804 307.369 59.8774 307.394 59.8796 307.42C59.8818 307.445 59.8892 307.47 59.9014 307.492C59.916 307.518 59.9369 307.539 59.9621 307.554C59.9872 307.569 60.0157 307.578 60.045 307.579Z",
    fill: "#364959"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3987 304.287H60.4849C62.3377 303.396 66.7903 303.842 68.6576 304.732C68.7015 304.752 68.7515 304.754 68.797 304.738C68.8425 304.722 68.8801 304.689 68.9018 304.646C68.9225 304.6 68.9251 304.548 68.9091 304.5C68.8931 304.452 68.8597 304.412 68.8155 304.388C66.8765 303.468 62.2803 303.023 60.3269 303.957C60.3042 303.966 60.2836 303.98 60.2667 303.997C60.2497 304.015 60.2367 304.036 60.2285 304.059C60.2204 304.082 60.2173 304.107 60.2194 304.131C60.2215 304.156 60.2288 304.179 60.2407 304.201C60.2577 304.227 60.281 304.249 60.3086 304.264C60.3363 304.279 60.3672 304.287 60.3987 304.287Z",
    fill: "#364959"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7063 301.036H60.7924C62.6453 300.146 67.0979 300.591 68.9651 301.467C68.9865 301.479 69.0102 301.486 69.0346 301.488C69.059 301.491 69.0836 301.487 69.1067 301.479C69.1298 301.471 69.1509 301.458 69.1686 301.441C69.1863 301.424 69.2002 301.404 69.2093 301.381C69.2293 301.337 69.2315 301.287 69.2154 301.242C69.1993 301.196 69.1663 301.158 69.1231 301.137C67.1841 300.218 62.5879 299.7 60.6345 300.706C60.6004 300.72 60.5714 300.744 60.5509 300.775C60.5305 300.805 60.5195 300.841 60.5195 300.878C60.5195 300.915 60.5305 300.951 60.5509 300.982C60.5714 301.012 60.6004 301.036 60.6345 301.051L60.7063 301.036Z",
    fill: "#364959"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3329 165.574C60.7764 196.295 59.8428 238.564 59.8428 238.564C59.613 240.891 57.3581 246.981 57.0422 261.013C56.7693 273.221 57.7028 295.957 57.7028 295.957C57.7028 295.957 65.1282 299.964 72.0653 297.709C72.0653 297.709 79.4476 259.979 82.1191 245.473C84.9916 229.315 87.6486 207.886 87.6486 207.886L89.1854 237.229C89.1854 237.229 88.6827 245.99 88.9269 252.108C89.1998 259.289 92.0866 289.551 92.0866 289.551C92.0866 289.551 101.35 295.023 108.56 289.551C108.56 289.551 111.189 242.83 111.433 234.256C111.893 217.451 114.217 189.741 113.757 168.025L63.3329 165.574Z",
    fill: "#263238"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7124 200.223C78.1475 207.586 77.5155 214.949 76.8165 222.312C76.4718 225.989 76.1128 229.68 75.725 233.343L75.1648 238.858L74.8776 241.615C74.777 242.535 74.6047 243.454 74.4754 244.359C73.3408 251.669 71.6029 264.926 70.3678 272.208C69.1326 279.489 67.7969 286.771 66.375 294.024C67.2559 286.68 68.2134 279.355 69.2475 272.05C70.3103 264.739 71.9477 251.482 73.111 244.186C73.2403 243.267 73.427 242.362 73.5275 241.443L73.8291 238.7L74.4611 233.199C74.892 229.522 75.3228 225.86 75.7824 222.197C76.7782 214.872 77.7549 207.548 78.7124 200.223Z",
    fill: "black"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M106.476 196.606C107.223 203.486 107.611 210.394 107.913 217.288C108.214 224.182 108.43 231.119 108.142 238.027C107.855 244.936 107.712 256.498 107.424 263.406C107.137 270.314 106.807 277.208 106.362 284.102C106.275 277.189 106.275 270.281 106.362 263.377C106.433 256.483 106.606 244.907 106.778 238.013L106.922 232.828V231.536V227.672L106.835 217.317L106.692 206.961C106.677 203.514 106.577 200.067 106.476 196.606Z",
    fill: "black"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5781 207.893L90.6661 191.075C90.6661 191.075 99.0537 189.897 103.362 186.076C103.362 186.076 100.576 191.132 92.6624 193.085L89.6032 207.951L89.1149 237.236L87.5781 207.893Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M120.073 118.796C113.485 109.416 111.967 108.683 102.698 107.899L100.285 127.676L125.446 151.109C137.635 151.109 124.884 125.647 120.073 118.796Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0908 112.64C62.0908 112.64 56.791 116.949 59.2183 127.807C60.8236 134.84 61.9369 141.976 62.5504 149.164C62.9382 154.909 62.2775 173.997 62.2775 173.997C78.0906 180.809 107.117 175.978 113.74 171.792C113.74 171.792 120.393 159.414 112.944 136.755C113.74 127.807 107.934 111.037 104.505 108.063L89.4747 105.251L78.0906 106.478L62.0908 112.64Z",
    fill: "#478CC8"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M73.872 74.7131C72.9977 74.8634 72.1736 75.2263 71.4724 75.7697C70.7712 76.3132 70.2142 77.0206 69.8505 77.8298C69.0462 79.2661 68.4143 82.1386 70.425 90.0092C71.1886 93.0958 72.4136 96.0494 74.0587 98.7703C74.5371 99.6551 75.3404 100.319 76.2993 100.623V94.5621L76.1557 90.3396C77.6625 88.356 78.7298 86.0745 79.2867 83.6466C79.6455 81.8138 79.5268 79.9195 78.942 78.1458L73.872 74.7131Z",
    fill: "#37474F"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9883 74.8938C73.6346 71.5042 78.0439 67.5114 86.3885 67.2242C93.225 66.9944 97.1747 69.4073 99.4727 73.4432C101.771 77.479 100.119 82.5921 100.119 82.5921L78.7333 80.7968L72.9883 74.8938Z",
    fill: "#37474F"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2543 75.9482C75.1785 76.749 74.8983 77.5169 74.4406 78.1783C73.9829 78.8397 73.363 79.3725 72.6403 79.7256C71.8461 80.1751 71.1798 80.82 70.7047 81.5992C70.2297 82.3784 69.9616 83.2661 69.9258 84.178C70.1355 83.448 70.5008 82.7722 70.9967 82.197C71.4926 81.6217 72.1072 81.1608 72.7983 80.8459C73.7456 80.3418 74.6283 79.7245 75.4266 79.0075C75.4266 79.0075 75.2256 80.5873 72.5541 82.6124C71.7889 83.2419 71.2029 84.0618 70.855 84.9896C70.507 85.9174 70.4095 86.9204 70.5721 87.8979C70.5702 87.1644 70.7316 86.4397 71.0446 85.7764C71.3576 85.1132 71.8144 84.5279 72.3818 84.0631C74.3494 82.3826 76.7623 81.6214 76.6905 79.108C76.6833 78.5105 76.5519 77.9211 76.3046 77.3771C76.0574 76.8331 75.6997 76.3465 75.2543 75.9482Z",
    fill: "#E0E0E0"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6703 96.1713C73.0258 97.4496 75.2663 95.3095 75.2663 95.3095L75.5105 107.805C75.5105 107.805 75.7115 110.232 79.5176 112.415C84.9035 115.518 87.2446 116.279 89.5714 119.597C91.4241 114.254 93.521 111.238 90.1171 107.087V104.214C91.3732 104.337 92.6384 104.337 93.8945 104.214C96.6808 103.827 98.4617 101.658 99.3522 98.656C100.955 92.3797 101.088 85.8181 99.74 79.4821C99.4562 78.0043 98.6634 76.6728 97.4995 75.7191C92.0848 71.4103 85.8658 74.369 81.1837 76.0925C79.2784 76.7236 77.2137 76.6779 75.3382 75.9632C76.918 77.7873 77.6792 79.5252 77.5787 88.1427C77.2745 88.7288 76.86 89.2506 76.3579 89.6795C75.3238 90.5412 74.5338 88.2432 73.7008 87.3384C73.2922 86.9825 72.8067 86.7261 72.2824 86.5896C71.758 86.453 71.2091 86.4398 70.6788 86.5512C70.1486 86.6625 69.6513 86.8953 69.2262 87.2313C68.8011 87.5672 68.4596 87.9972 68.2287 88.4873C67.5454 89.8322 67.4184 91.3919 67.8752 92.8296C68.3321 94.2673 69.336 95.4676 70.6703 96.1713Z",
    fill: "#FFBDA7"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1004 81.658L83.2503 83.756C82.9751 83.36 82.8631 82.8732 82.9374 82.3967C83.0118 81.9203 83.2668 81.4908 83.6495 81.1974C83.8384 81.0601 84.0533 80.9627 84.2811 80.9114C84.5089 80.8601 84.7448 80.8559 84.9743 80.899C85.2038 80.9421 85.4221 81.0317 85.6157 81.1622C85.8094 81.2927 85.9743 81.4614 86.1004 81.658Z",
    fill: "#263238"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5696 83.2081L95.0426 82.6831C95.062 82.4511 95.1288 82.2255 95.2389 82.0204C95.349 81.8153 95.5 81.635 95.6826 81.4906C95.8652 81.3462 96.0755 81.2409 96.3005 81.1811C96.5255 81.1213 96.7604 81.1084 96.9906 81.143C97.4674 81.2212 97.8964 81.4784 98.1898 81.8622C98.4833 82.2461 98.6191 82.7275 98.5696 83.2081Z",
    fill: "#263238"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6739 86.8659C84.7077 87.1476 84.8241 87.413 85.0084 87.6287C85.1926 87.8444 85.4366 88.0008 85.7095 88.0783C85.9824 88.1557 86.2721 88.1507 86.5422 88.0639C86.8123 87.9771 87.0507 87.8124 87.2274 87.5904C87.4041 87.3685 87.5113 87.0992 87.5353 86.8165C87.5594 86.5339 87.4994 86.2504 87.3628 86.0017C87.2261 85.7531 87.019 85.5504 86.7675 85.4192C86.516 85.2879 86.2313 85.234 85.9492 85.2642C85.7602 85.2853 85.5771 85.3435 85.4106 85.4355C85.2442 85.5275 85.0975 85.6514 84.979 85.8003C84.8605 85.9491 84.7726 86.1198 84.7202 86.3027C84.6679 86.4855 84.6521 86.6769 84.6739 86.8659Z",
    fill: "#263238"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3505 85.755C95.3855 86.0361 95.5028 86.3007 95.6876 86.5155C95.8724 86.7302 96.1166 86.8856 96.3894 86.9621C96.6622 87.0386 96.9515 87.0329 97.2211 86.9456C97.4906 86.8583 97.7284 86.6933 97.9045 86.4714C98.0807 86.2495 98.1874 85.9804 98.2112 85.6981C98.235 85.4158 98.1749 85.1327 98.0385 84.8844C97.902 84.6361 97.6953 84.4336 97.4442 84.3023C97.193 84.1711 96.9088 84.1169 96.627 84.1466C96.4372 84.1676 96.2535 84.2259 96.0864 84.3182C95.9193 84.4106 95.7721 84.5351 95.6534 84.6847C95.5347 84.8342 95.4468 85.0058 95.3948 85.1895C95.3428 85.3732 95.3278 85.5654 95.3505 85.755Z",
    fill: "#263238"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6211 84.5112L92.0495 93.6878L97.197 91.5346C95.5591 88.7302 93.3118 86.3299 90.6211 84.5112Z",
    fill: "#E99678"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M91.368 97.3279L91.336 97.2807C91.2828 97.2344 91.217 97.205 91.147 97.1962C90.5903 97.1287 90.0389 97.022 89.4972 96.8769C89.0323 96.7265 88.5924 96.5075 88.192 96.2273C87.8658 95.9057 87.5158 95.6091 87.1451 95.3401C87.1206 95.3281 87.0937 95.3218 87.0665 95.3217C87.0392 95.3215 87.0123 95.3275 86.9877 95.3392C86.963 95.3509 86.9414 95.3679 86.9242 95.3891C86.9071 95.4103 86.895 95.4351 86.8888 95.4616C86.8479 95.885 87.4069 96.3218 87.7156 96.5664C88.087 96.859 88.507 97.0839 88.9563 97.231C89.4349 97.3886 89.9316 97.4847 90.4345 97.517C90.6889 97.5378 90.9443 97.5415 91.1992 97.528C91.3254 97.4772 91.4067 97.4107 91.368 97.3279Z",
    fill: "#E99678"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1823 187.584L79.0674 187.498C77.5306 186.521 76.08 185.372 74.5863 184.324C74.0117 183.94 73.4008 183.612 72.7623 183.347C72.1591 183.103 71.5128 183.002 70.8808 182.801C70.2489 182.6 69.5595 182.227 68.8701 181.968C68.0948 181.729 67.4028 181.276 66.8737 180.661C66.3163 179.989 65.8346 179.256 65.4374 178.478C65.1228 177.862 64.854 177.224 64.6331 176.568C61.301 176.41 58.4429 178.45 56.0156 182.73C56.389 183.39 56.7337 183.979 57.0354 184.482C59.5775 188.604 59.3046 192.654 63.3405 196.934C66.5814 196.506 69.5255 194.825 71.5415 192.252C72.1323 191.421 72.6149 190.519 72.9777 189.566C72.9777 189.566 72.5756 188.891 72.5469 188.762C72.5182 188.633 72.6187 188.345 72.9059 188.317C73.4545 188.34 73.9861 188.514 74.4427 188.819C74.9738 189.171 75.5618 189.429 76.1806 189.581C76.7144 189.653 77.2554 189.653 77.7892 189.581C78.5089 189.57 79.2109 189.355 79.8143 188.963C80.3744 188.446 79.6563 187.886 79.1823 187.584Z",
    fill: "#FFBDA7"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M43.541 164.836C46.4853 169.59 52.8479 177.404 56.1369 182.732C59.4259 188.061 64.7544 176.571 64.7544 176.571C62.0542 168.858 59.7993 160.671 59.7993 160.671C59.7993 160.671 53.8963 157.066 48.4529 158.589C47.0062 158.838 45.7032 159.614 44.796 160.768C43.8887 161.922 43.4415 163.372 43.541 164.836Z",
    fill: "#FFBDA7"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6987 147.499C44.0057 142.444 48.6734 126.846 50.2102 122.336C52.2497 116.347 54.519 114.767 62.088 112.627C68.2926 119.105 65.7217 135.291 65.7217 135.291C65.7217 135.291 60.3214 152.296 60.0485 153.445C59.7757 154.594 60.0486 155.485 58.8996 156.418C56.2281 155.14 43.345 154.278 41.205 156.935C39.2086 154.436 41.8082 150.918 42.6987 147.499Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9005 156.489C59.6042 156.877 59.0585 157.537 59.4175 158.844C59.7766 160.151 60.782 160.726 60.15 161.229C55.5473 160.093 50.7062 160.409 46.2902 162.133C43.0587 163.326 43.547 164.891 43.547 164.891C42.5416 165.279 41.6798 163.785 41.5649 162.019C41.3031 160.38 41.183 158.722 41.2059 157.063C41.8522 154.536 51.6905 153.861 58.9005 156.489Z",
    fill: "#CCCCCC"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4671 196.927C66.6613 196.467 69.5538 194.789 71.5388 192.244C72.1276 191.459 72.6105 190.599 72.975 189.688C72.2343 191.043 71.2281 192.235 70.0164 193.192C69.2514 193.999 68.2931 194.596 67.2323 194.928C66.1715 195.26 65.0435 195.315 63.9554 195.088C62.4345 194.494 61.1488 193.42 60.293 192.029C61.0455 193.84 62.121 195.5 63.4671 196.927Z",
    fill: "#F0997A"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1257 76.4526H99.0252C92.3034 75.6509 85.5047 77.0843 79.6789 80.5316C79.4778 80.6321 79.291 80.747 79.1043 80.8619L78.9464 80.9625C76.4466 82.378 74.3005 84.3423 72.67 86.7075C72.1533 86.5225 71.6045 86.4437 71.0567 86.4758C70.5088 86.5078 69.9731 86.6502 69.4815 86.8942C69.3809 86.5495 68.8639 83.6913 68.8208 83.4041C68.0021 77.6591 69.5677 70.0326 79.3485 66.7723C88.0809 63.8998 96.1383 66.5138 98.0198 71.8997C98.4363 73.0631 98.824 75.2318 99.1257 76.4526Z",
    fill: "#263238"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7188 79.6776C80.299 76.7938 82.6256 74.3878 85.4548 72.7117C88.6576 70.6866 95.5085 70.0834 98.539 69.8392C103.896 69.5233 105.261 70.5717 105.39 71.2755C105.39 71.4622 105.562 72.324 105.605 72.525C105.642 72.7005 105.617 72.8832 105.534 73.0421C104.815 74.3204 100.65 76.7476 100.65 76.7476C93.8137 75.3975 85.5266 77.1067 78.9342 80.8122L78.7188 79.6776Z",
    fill: "#37474F"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9453 80.9493C85.5634 77.3078 93.1743 75.8833 100.661 76.8846C100.661 76.8846 104.827 74.4574 105.545 73.1791C105.918 72.4754 105.401 70.7806 98.7655 71.1684C95.692 71.3551 88.8842 71.9583 85.6813 74.0409C82.8597 75.7012 80.5338 78.0865 78.9453 80.9493Z",
    fill: "#263238"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M121.85 135.531C119.775 129.242 115.726 126.255 112.091 122.174C108.456 118.094 106.384 115.601 104.706 112.97C103.028 110.339 101.351 106.285 101.104 104.037C100.945 102.313 100.926 100.579 101.049 98.8525C101.13 97.6736 100.665 97.6854 99.6737 98.0354C98.6824 98.3854 97.744 99.1877 97.3601 101.298C96.9762 103.408 97.07 104.592 96.6025 104.637C96.1349 104.682 93.1787 102.789 91.5413 101.974C89.9039 101.159 89.4053 101.271 87.357 101.625C85.7122 101.865 84.1204 102.384 82.6497 103.159C81.9145 103.656 81.0663 105.162 80.6882 105.674C80.1655 106.409 81.6103 107.031 82.7657 106.183L83.8993 105.348C83.5165 105.886 83.713 106.411 83.8368 107.098C83.9459 107.554 84.2193 107.953 84.6045 108.22C84.6045 108.22 84.1767 108.503 84.2536 109.397C84.3 109.934 84.4778 110.451 84.7713 110.902C84.6199 110.928 84.48 111 84.3704 111.107C84.2607 111.215 84.1864 111.353 84.1574 111.504C84.011 112.061 83.8573 112.935 86.0149 113.965C88.1725 114.995 89.7309 115.655 91.5523 116.421C92.7504 116.869 93.8691 117.507 94.8662 118.308C96.1438 119.334 97.0892 121.429 98.6938 124.774C102.298 132.18 103.122 134.042 105.89 138.397C107.991 141.708 110.307 145.096 115.461 147.962C120.008 150.491 121.693 147.739 122.278 144.766C122.789 141.692 122.643 138.545 121.85 135.531Z",
    fill: "#FFCAB8"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M121.845 135.531C120.22 129.607 115.321 125.587 111.464 121.131C109.478 118.917 107.604 116.604 105.849 114.203C103.691 111.201 102.177 107.786 101.402 104.171C101.215 102.33 101.191 100.477 101.33 98.6318C101.405 96.7495 99.0579 97.8158 98.3265 98.5813C96.9454 100.043 97.0662 102.168 96.7508 103.995C96.7268 104.149 96.6578 104.452 96.5884 104.435C94.4716 103.604 92.591 102.067 90.3756 101.355C89.6237 101.193 88.8443 101.208 88.0993 101.4C86.6164 101.634 85.1633 102.029 83.7657 102.578C82.2369 103.038 81.484 104.477 80.7091 105.737C81.537 104.525 82.31 103.132 83.8235 102.727C85.2205 102.225 86.6676 101.875 88.1396 101.683C88.8457 101.519 89.5797 101.517 90.2866 101.677C92.5085 102.432 94.3169 104.048 96.5324 104.888C97.3478 104.976 97.2589 103.489 97.3889 102.962C97.6101 101.568 97.6912 99.985 98.7063 98.9479C99.2035 98.4792 99.8392 98.1842 100.518 98.1069C100.828 98.0907 100.767 98.3784 100.791 98.6278C100.647 101.237 100.515 103.97 101.372 106.476C103.125 112.291 107.117 117.027 111.133 121.436C115.148 125.844 119.972 129.676 121.849 135.524L121.845 135.531Z",
    fill: "#E99678"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2145 104.566C87.4712 104.187 85.1196 103.748 83.8864 105.402C84.6298 104.883 85.5255 104.626 86.4312 104.674C87.2553 104.663 88.3987 104.626 89.2145 104.566Z",
    fill: "#E99678"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7921 108.183C87.4236 107.731 85.9408 107.765 84.5948 108.28C85.9944 108.353 87.3974 108.32 88.7921 108.183Z",
    fill: "#E99678"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6399 111.61C87.3665 111.29 86.0697 111.071 84.7617 110.957C85.9306 111.643 87.3108 111.875 88.6399 111.61Z",
    fill: "#E99678"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M118.763 129.363C119.042 129.337 119.027 129.339 119.184 129.264C119.514 129.107 119.893 129.082 120.241 129.195C120.59 129.307 120.882 129.548 121.059 129.869C122.341 131.99 125.861 136.395 126.912 141.368C128.163 147.292 125.604 151.153 125.604 151.153C125.604 151.153 121.1 151.608 118.02 150.421C114.157 148.934 114.115 147.271 114.115 147.271C114.771 147.505 115.458 147.639 116.153 147.667C116.153 147.667 122.194 138.373 118.763 129.363Z",
    fill: "#CCCCCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1509_12467",
    x1: 361.379,
    y1: 301.753,
    x2: 380.975,
    y2: 343.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1509_12467",
    x1: 460.159,
    y1: 244.05,
    x2: 479.775,
    y2: 286.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1509_12467",
    x1: 380.765,
    y1: 256.143,
    x2: 371.753,
    y2: 239.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1509_12467",
    x1: 381.097,
    y1: 222.257,
    x2: 375.953,
    y2: 204.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1509_12467",
    x1: 373.998,
    y1: 251.958,
    x2: 359.92,
    y2: 213.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1509_12467",
    x1: 350.999,
    y1: 229.141,
    x2: 363.29,
    y2: 195.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1509_12467",
    x1: 396.699,
    y1: 234.155,
    x2: 405.047,
    y2: 248.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1509_12467",
    x1: 484.361,
    y1: 372.76,
    x2: 503.958,
    y2: 414.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1509_12467",
    x1: 583.146,
    y1: 315.056,
    x2: 602.762,
    y2: 357.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1509_12467",
    x1: 499.915,
    y1: 320.279,
    x2: 509.544,
    y2: 336.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1509_12467",
    x1: 504.083,
    y1: 293.264,
    x2: 498.939,
    y2: 275.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1509_12467",
    x1: 496.98,
    y1: 322.964,
    x2: 482.903,
    y2: 284.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1509_12467",
    x1: 473.981,
    y1: 300.148,
    x2: 486.272,
    y2: 266.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1509_12467",
    x1: 519.686,
    y1: 305.161,
    x2: 528.034,
    y2: 319.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1509_12467",
    x1: 665.483,
    y1: 494.082,
    x2: 518.742,
    y2: 179.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#988E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A49A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1509_12467",
    x1: 567.263,
    y1: 247.83,
    x2: 559.03,
    y2: 232.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C3D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#712A15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1509_12467",
    x1: 585.645,
    y1: 275.742,
    x2: 529.729,
    y2: 178.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C5F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1509_12467",
    x1: 573.933,
    y1: 159.053,
    x2: 580.411,
    y2: 169.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0969B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1509_12467",
    x1: 535.898,
    y1: 137.602,
    x2: 540.685,
    y2: 144.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0969B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1509_12467",
    x1: 545.08,
    y1: 139.219,
    x2: 550.27,
    y2: 148.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0969B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1509_12467",
    x1: 562.179,
    y1: 146.402,
    x2: 554.704,
    y2: 159.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A82B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1509_12467",
    x1: 445.452,
    y1: 225.016,
    x2: 452.785,
    y2: 212.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB7A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A82B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1509_12467",
    x1: 381.983,
    y1: 60.2616,
    x2: 487.195,
    y2: 250.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C5F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1509_12467",
    x1: 415.367,
    y1: 207.447,
    x2: 419.011,
    y2: 213.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0969B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1509_12467",
    x1: 429.859,
    y1: 213.734,
    x2: 433.753,
    y2: 220.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0969B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1509_12467",
    x1: 429.707,
    y1: 221.31,
    x2: 428.851,
    y2: 213.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC4C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1509_12467",
    x1: 426.246,
    y1: 211.294,
    x2: 427.224,
    y2: 217.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0969B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1509_12467",
    x1: 466.804,
    y1: 234.625,
    x2: 473.529,
    y2: 245.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0969B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1509_12467",
    x1: 463.762,
    y1: 237.384,
    x2: 464.355,
    y2: 243.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0969B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC4C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1509_12467",
    x1: 349.677,
    y1: 419.964,
    x2: 353,
    y2: 425.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A42517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791D10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1509_12467",
    x1: 386.812,
    y1: 471.055,
    x2: 383.024,
    y2: 488.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1509_12467",
    x1: 316.163,
    y1: 452.628,
    x2: 307.421,
    y2: 437.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1509_12467",
    x1: 320.732,
    y1: 443.415,
    x2: 320.732,
    y2: 470.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1509_12467",
    x1: 367.672,
    y1: 460.579,
    x2: 369.143,
    y2: 432.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1509_12467",
    x1: 406.188,
    y1: 493.815,
    x2: 359.966,
    y2: 413.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1509_12467",
    x1: 373.199,
    y1: 470.574,
    x2: 373.199,
    y2: 497.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1509_12467",
    x1: 310.381,
    y1: 442.658,
    x2: 313.704,
    y2: 448.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A42517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791D10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1509_12467",
    x1: 187.002,
    y1: 364.743,
    x2: 190.328,
    y2: 370.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A42517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791D10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1509_12467",
    x1: 151.367,
    y1: 434.308,
    x2: 205.613,
    y2: 369.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1509_12467",
    x1: 209.354,
    y1: 383.348,
    x2: 213.469,
    y2: 376.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2822"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1509_12467",
    x1: 224.875,
    y1: 392.666,
    x2: 228.979,
    y2: 385.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2822"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1509_12467",
    x1: 240.247,
    y1: 402.248,
    x2: 244.658,
    y2: 394.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2822"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1509_12467",
    x1: 254.807,
    y1: 409.676,
    x2: 247.804,
    y2: 409.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1509_12467",
    x1: 276.691,
    y1: 417.384,
    x2: 281.923,
    y2: 408.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1509_12467",
    x1: 344.718,
    y1: 371.828,
    x2: 384.463,
    y2: 443.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1509_12467",
    x1: 270.466,
    y1: 435.29,
    x2: 301.96,
    y2: 436.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1509_12467",
    x1: 430.656,
    y1: 406.208,
    x2: 439.412,
    y2: 422.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1509_12467",
    x1: 441.209,
    y1: 410.879,
    x2: 449.955,
    y2: 418.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1509_12467",
    x1: 433.679,
    y1: 406.284,
    x2: 443.753,
    y2: 424.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1509_12467",
    x1: 373.732,
    y1: 405.081,
    x2: 446.841,
    y2: 536.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1509_12467",
    x1: 387.251,
    y1: 437.698,
    x2: 407.743,
    y2: 479.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C4F1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1509_12467",
    x1: 387.189,
    y1: 397.621,
    x2: 460.3,
    y2: 529.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1509_12467",
    x1: 384.331,
    y1: 439.44,
    x2: 399.191,
    y2: 466.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1509_12467",
    x1: 382.218,
    y1: 451.488,
    x2: 394.189,
    y2: 496.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1509_12467",
    x1: 408.519,
    y1: 452.65,
    x2: 416.749,
    y2: 467.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1509_12467",
    x1: 370.535,
    y1: 445.849,
    x2: 314.79,
    y2: 349.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1509_12467",
    x1: 360.606,
    y1: 431.957,
    x2: 320.87,
    y2: 431.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1509_12467",
    x1: 371.1,
    y1: 457.456,
    x2: 372.378,
    y2: 456.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1509_12467",
    x1: 374.965,
    y1: 457.399,
    x2: 376.73,
    y2: 457.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1509_12467",
    x1: 415.362,
    y1: 482.718,
    x2: 409.665,
    y2: 472.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1509_12467",
    x1: 371.891,
    y1: 406.103,
    x2: 445.001,
    y2: 537.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1509_12467",
    x1: 394.091,
    y1: 477.405,
    x2: 404.133,
    y2: 495.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1509_12467",
    x1: 394.163,
    y1: 483.868,
    x2: 391.009,
    y2: 483.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1509_12467",
    x1: 396.489,
    y1: 479.374,
    x2: 394.953,
    y2: 476.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1509_12467",
    x1: 428.635,
    y1: 457.46,
    x2: 438.676,
    y2: 475.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1509_12467",
    x1: 428.706,
    y1: 463.923,
    x2: 425.552,
    y2: 463.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1509_12467",
    x1: 431.032,
    y1: 459.428,
    x2: 429.496,
    y2: 456.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1509_12467",
    x1: 396.209,
    y1: 490.343,
    x2: 406.372,
    y2: 508.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1509_12467",
    x1: 396.007,
    y1: 495.348,
    x2: 392.854,
    y2: 495.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1509_12467",
    x1: 398.155,
    y1: 492.67,
    x2: 396.647,
    y2: 489.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1509_12467",
    x1: 430.763,
    y1: 470.396,
    x2: 440.925,
    y2: 488.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1509_12467",
    x1: 430.561,
    y1: 475.402,
    x2: 427.408,
    y2: 475.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1509_12467",
    x1: 432.708,
    y1: 472.724,
    x2: 431.201,
    y2: 470.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1509_12467",
    x1: 387.322,
    y1: 491.07,
    x2: 359.773,
    y2: 443.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1509_12467",
    x1: 382.528,
    y1: 485.024,
    x2: 362.931,
    y2: 484.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4874C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1509_12467",
    x1: 379.426,
    y1: 437.612,
    x2: 389.5,
    y2: 455.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1509_12467",
    x1: 209.592,
    y1: 379.258,
    x2: 209.592,
    y2: 406.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1509_12467",
    x1: 225.282,
    y1: 388.306,
    x2: 225.282,
    y2: 415.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1509_12467",
    x1: 240.974,
    y1: 397.353,
    x2: 240.974,
    y2: 424.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFABA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8968D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1509_12467",
    x1: 314.396,
    y1: 442.719,
    x2: 313.584,
    y2: 441.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A42517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791D10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.244 206.986) rotate(-17.0741) scale(42.6046 42.6046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.193 237.369) rotate(-17.0741) scale(101.349 101.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.596 199.633) rotate(-17.0741) scale(42.6046 42.6046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.548 230.015) rotate(-17.0741) scale(101.349 101.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.6 191.903) rotate(-17.0741) scale(42.6046 42.6046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.548 222.286) rotate(-17.0741) scale(101.349 101.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.701 182.383) rotate(-17.0741) scale(42.6046 42.6046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.65 212.765) rotate(-17.0741) scale(101.349 101.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.732 168.601) rotate(-46.6167) scale(39.7154 39.7154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.796 179.025) rotate(-46.6167) scale(94.4758 94.4758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.443 90.2768) rotate(23.2737) scale(39.7153 39.7153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.079 130.555) rotate(23.2737) scale(94.476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.894 82.0034) rotate(-68.3328) scale(41.3182 41.3182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_1509_12467",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.665 77.0358) rotate(-68.3328) scale(98.2885 98.2884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2273,
    stopColor: "#FCDB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#FCD06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCC6B"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fuel-logo.fdfdb135.svg";